// GENERATED by scripts/importSong.ts from song-imports/golden/ -- re-run the
// importer to regenerate rather than hand-editing the chart notes below.
import type { SongMeta } from '@/types';

export const goldenSong: SongMeta = {
  "id": "golden",
  "title": "Golden",
  "artist": "Imported",
  "bpm": 120,
  "duration": 179.2,
  "audio": "audio/songs/golden.mp3",
  "vocalsAudio": "audio/songs/golden-vocals.mp3",
  "difficulty": 3,
  "background": "sunsetHill",
  "chart": {
    "noteTravelTime": 1.9,
    "notes": [
      {
        "time": 10.823,
        "lane": "left",
        "x": 0.08,
        "type": "iceCream",
        "pitch": 38,
        "vocalDuration": 0.094
      },
      {
        "time": 16.276,
        "lane": "right",
        "x": 0.63,
        "type": "fish",
        "pitch": 62,
        "vocalDuration": 0.068
      },
      {
        "time": 16.438,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 59,
        "vocalDuration": 0.198
      },
      {
        "time": 16.635,
        "lane": "right",
        "x": 0.63,
        "type": "cupcake",
        "pitch": 62,
        "vocalDuration": 0.141
      },
      {
        "time": 16.776,
        "lane": "left",
        "x": 0.39,
        "type": "candy",
        "pitch": 63,
        "vocalDuration": 0.219
      },
      {
        "time": 16.995,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 63,
        "vocalDuration": 0.219
      },
      {
        "time": 17.214,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 61,
        "vocalDuration": 0.266
      },
      {
        "time": 17.479,
        "lane": "right",
        "x": 0.38,
        "type": "fish",
        "pitch": 60,
        "vocalDuration": 0.146
      },
      {
        "time": 17.63,
        "lane": "left",
        "x": 0.63,
        "type": "donut",
        "pitch": 61,
        "vocalDuration": 0.172
      },
      {
        "time": 17.802,
        "lane": "right",
        "x": 0.27,
        "type": "cupcake",
        "pitch": 63,
        "vocalDuration": 0.286
      },
      {
        "time": 18.089,
        "lane": "left",
        "x": 0.64,
        "type": "candy",
        "pitch": 63,
        "vocalDuration": 0.286
      },
      {
        "time": 18.375,
        "lane": "right",
        "x": 0.14,
        "type": "sushi",
        "pitch": 61,
        "vocalDuration": 0.167
      },
      {
        "time": 18.583,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 63,
        "vocalDuration": 0.115
      },
      {
        "time": 18.781,
        "lane": "right",
        "x": 0.28,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.401
      },
      {
        "time": 19.214,
        "lane": "left",
        "x": 0.4,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.38
      },
      {
        "time": 19.62,
        "lane": "right",
        "x": 0.38,
        "type": "cupcake",
        "pitch": 59,
        "vocalDuration": 0.333
      },
      {
        "time": 19.964,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 61,
        "vocalDuration": 0.237
      },
      {
        "time": 20.201,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 61,
        "vocalDuration": 0.237
      },
      {
        "time": 20.682,
        "lane": "left",
        "x": 0.16,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.222
      },
      {
        "time": 20.905,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.222
      },
      {
        "time": 21.127,
        "lane": "left",
        "x": 0.28,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.222
      },
      {
        "time": 21.641,
        "lane": "right",
        "x": 0.62,
        "type": "cupcake",
        "pitch": 58,
        "vocalDuration": 0.267
      },
      {
        "time": 21.908,
        "lane": "left",
        "x": 0.37,
        "type": "candy",
        "pitch": 58,
        "vocalDuration": 0.267
      },
      {
        "time": 22.174,
        "lane": "right",
        "x": 0.49,
        "type": "sushi",
        "pitch": 58,
        "vocalDuration": 0.267
      },
      {
        "time": 22.441,
        "lane": "left",
        "x": 0.49,
        "type": "iceCream",
        "pitch": 58,
        "vocalDuration": 0.267
      },
      {
        "time": 22.714,
        "lane": "right",
        "x": 0.37,
        "type": "fish",
        "pitch": 58,
        "vocalDuration": 0.172
      },
      {
        "time": 22.891,
        "lane": "left",
        "x": 0.66,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.242
      },
      {
        "time": 23.133,
        "lane": "right",
        "x": 0.3,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.242
      },
      {
        "time": 23.375,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.396
      },
      {
        "time": 23.776,
        "lane": "right",
        "x": 0.18,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 24.008,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 24.406,
        "lane": "right",
        "x": 0.25,
        "type": "fish",
        "pitch": 59,
        "vocalDuration": 0.208
      },
      {
        "time": 24.62,
        "lane": "left",
        "x": 0.39,
        "type": "donut",
        "pitch": 63,
        "vocalDuration": 0.318
      },
      {
        "time": 24.938,
        "lane": "right",
        "x": 0.39,
        "type": "cupcake",
        "pitch": 63,
        "vocalDuration": 0.318
      },
      {
        "time": 25.26,
        "lane": "left",
        "x": 0.26,
        "type": "candy",
        "pitch": 61,
        "vocalDuration": 0.203
      },
      {
        "time": 25.469,
        "lane": "right",
        "x": 0.5,
        "type": "sushi",
        "pitch": 60,
        "vocalDuration": 0.146
      },
      {
        "time": 25.62,
        "lane": "left",
        "x": 0.14,
        "type": "iceCream",
        "pitch": 62,
        "vocalDuration": 0.177
      },
      {
        "time": 25.797,
        "lane": "right",
        "x": 0.64,
        "type": "fish",
        "pitch": 63,
        "vocalDuration": 0.255
      },
      {
        "time": 26.052,
        "lane": "left",
        "x": 0.27,
        "type": "donut",
        "pitch": 63,
        "vocalDuration": 0.255
      },
      {
        "time": 26.313,
        "lane": "right",
        "x": 0.63,
        "type": "cupcake",
        "pitch": 61,
        "vocalDuration": 0.375
      },
      {
        "time": 26.766,
        "lane": "left",
        "x": 0.4,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.198
      },
      {
        "time": 27.411,
        "lane": "right",
        "x": 0.52,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.068
      },
      {
        "time": 27.635,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.339
      },
      {
        "time": 27.974,
        "lane": "right",
        "x": 0.38,
        "type": "fish",
        "pitch": 61,
        "vocalDuration": 0.365
      },
      {
        "time": 28.474,
        "lane": "left",
        "x": 0.63,
        "type": "donut",
        "pitch": 61,
        "vocalDuration": 0.109
      },
      {
        "time": 28.792,
        "lane": "right",
        "x": 0.29,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.266
      },
      {
        "time": 29.057,
        "lane": "left",
        "x": 0.66,
        "type": "candy",
        "pitch": 70,
        "vocalDuration": 0.266
      },
      {
        "time": 29.323,
        "lane": "right",
        "x": 0.17,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.266
      },
      {
        "time": 29.594,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.234
      },
      {
        "time": 29.828,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.208
      },
      {
        "time": 30.036,
        "lane": "left",
        "x": 0.41,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.224
      },
      {
        "time": 30.26,
        "lane": "right",
        "x": 0.41,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.224
      },
      {
        "time": 30.49,
        "lane": "left",
        "x": 0.3,
        "type": "candy",
        "pitch": 70,
        "vocalDuration": 0.141
      },
      {
        "time": 30.813,
        "lane": "right",
        "x": 0.53,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.25
      },
      {
        "time": 31.063,
        "lane": "left",
        "x": 0.17,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.25
      },
      {
        "time": 31.313,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.25
      },
      {
        "time": 31.766,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.234
      },
      {
        "time": 32.266,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.297
      },
      {
        "time": 32.76,
        "lane": "left",
        "x": 0.43,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.227
      },
      {
        "time": 32.987,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.227
      },
      {
        "time": 33.281,
        "lane": "left",
        "x": 0.52,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.229
      },
      {
        "time": 33.51,
        "lane": "right",
        "x": 0.4,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.229
      },
      {
        "time": 33.755,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.323
      },
      {
        "time": 34.25,
        "lane": "right",
        "x": 0.31,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.25
      },
      {
        "time": 34.5,
        "lane": "left",
        "x": 0.67,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.25
      },
      {
        "time": 34.766,
        "lane": "right",
        "x": 0.18,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.266
      },
      {
        "time": 35.031,
        "lane": "left",
        "x": 0.55,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.266
      },
      {
        "time": 35.474,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.359
      },
      {
        "time": 36.016,
        "lane": "left",
        "x": 0.43,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.257
      },
      {
        "time": 36.272,
        "lane": "right",
        "x": 0.43,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.257
      },
      {
        "time": 36.529,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.257
      },
      {
        "time": 36.785,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.257
      },
      {
        "time": 37.047,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.078
      },
      {
        "time": 37.13,
        "lane": "right",
        "x": 0.67,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.284
      },
      {
        "time": 37.414,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.284
      },
      {
        "time": 37.698,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.284
      },
      {
        "time": 37.982,
        "lane": "left",
        "x": 0.43,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.284
      },
      {
        "time": 38.276,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.411
      },
      {
        "time": 38.698,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.271
      },
      {
        "time": 39.281,
        "lane": "right",
        "x": 0.4,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.219
      },
      {
        "time": 39.5,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.219
      },
      {
        "time": 39.745,
        "lane": "right",
        "x": 0.31,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.219
      },
      {
        "time": 39.974,
        "lane": "left",
        "x": 0.67,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.104
      },
      {
        "time": 40.24,
        "lane": "right",
        "x": 0.18,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.234
      },
      {
        "time": 40.552,
        "lane": "left",
        "x": 0.55,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.167
      },
      {
        "time": 40.766,
        "lane": "right",
        "x": 0.31,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.247
      },
      {
        "time": 41.013,
        "lane": "left",
        "x": 0.43,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.247
      },
      {
        "time": 41.292,
        "lane": "right",
        "x": 0.4,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.232
      },
      {
        "time": 41.523,
        "lane": "left",
        "x": 0.28,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.232
      },
      {
        "time": 41.776,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.214
      },
      {
        "time": 42.276,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.286
      },
      {
        "time": 42.755,
        "lane": "right",
        "x": 0.67,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.276
      },
      {
        "time": 43.042,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.208
      },
      {
        "time": 43.281,
        "lane": "right",
        "x": 0.66,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.115
      },
      {
        "time": 43.521,
        "lane": "left",
        "x": 0.4,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.37
      },
      {
        "time": 43.974,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.24
      },
      {
        "time": 44.328,
        "lane": "left",
        "x": 0.55,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.25
      },
      {
        "time": 44.693,
        "lane": "right",
        "x": 0.43,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.271
      },
      {
        "time": 44.964,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.271
      },
      {
        "time": 45.286,
        "lane": "right",
        "x": 0.29,
        "type": "cupcake",
        "pitch": 69,
        "vocalDuration": 0.057
      },
      {
        "time": 45.344,
        "lane": "left",
        "x": 0.67,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.307
      },
      {
        "time": 45.656,
        "lane": "right",
        "x": 0.17,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.266
      },
      {
        "time": 45.948,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.094
      },
      {
        "time": 46.047,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.141
      },
      {
        "time": 46.193,
        "lane": "left",
        "x": 0.41,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.276
      },
      {
        "time": 46.469,
        "lane": "right",
        "x": 0.41,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.276
      },
      {
        "time": 46.745,
        "lane": "left",
        "x": 0.29,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.276
      },
      {
        "time": 47.021,
        "lane": "right",
        "x": 0.53,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.276
      },
      {
        "time": 47.297,
        "lane": "left",
        "x": 0.17,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.276
      },
      {
        "time": 47.573,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.276
      },
      {
        "time": 47.943,
        "lane": "left",
        "x": 0.29,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.271
      },
      {
        "time": 48.214,
        "lane": "right",
        "x": 0.65,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.271
      },
      {
        "time": 48.49,
        "lane": "left",
        "x": 0.42,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.245
      },
      {
        "time": 48.734,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.245
      },
      {
        "time": 49.01,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.25
      },
      {
        "time": 49.26,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.25
      },
      {
        "time": 49.51,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.25
      },
      {
        "time": 49.813,
        "lane": "right",
        "x": 0.28,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.224
      },
      {
        "time": 50.036,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.224
      },
      {
        "time": 50.26,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.224
      },
      {
        "time": 50.49,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.135
      },
      {
        "time": 50.63,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.286
      },
      {
        "time": 50.964,
        "lane": "left",
        "x": 0.45,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.125
      },
      {
        "time": 51.094,
        "lane": "right",
        "x": 0.46,
        "type": "cupcake",
        "pitch": 80,
        "vocalDuration": 0.161
      },
      {
        "time": 51.26,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.232
      },
      {
        "time": 51.492,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.232
      },
      {
        "time": 51.75,
        "lane": "left",
        "x": 0.17,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.238
      },
      {
        "time": 51.988,
        "lane": "right",
        "x": 0.66,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.238
      },
      {
        "time": 52.226,
        "lane": "left",
        "x": 0.3,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.238
      },
      {
        "time": 52.484,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.242
      },
      {
        "time": 52.727,
        "lane": "left",
        "x": 0.43,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.242
      },
      {
        "time": 52.995,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.141
      },
      {
        "time": 53.141,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.193
      },
      {
        "time": 53.333,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.247
      },
      {
        "time": 53.58,
        "lane": "left",
        "x": 0.69,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.247
      },
      {
        "time": 53.826,
        "lane": "right",
        "x": 0.32,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.247
      },
      {
        "time": 54.073,
        "lane": "left",
        "x": 0.68,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.306
      },
      {
        "time": 54.378,
        "lane": "right",
        "x": 0.19,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.306
      },
      {
        "time": 54.684,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.306
      },
      {
        "time": 55.5,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.219
      },
      {
        "time": 55.724,
        "lane": "left",
        "x": 0.41,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 55.976,
        "lane": "right",
        "x": 0.41,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 56.227,
        "lane": "left",
        "x": 0.29,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.252
      },
      {
        "time": 56.49,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 56.721,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 56.984,
        "lane": "right",
        "x": 0.68,
        "type": "fish",
        "pitch": 74,
        "vocalDuration": 0.12
      },
      {
        "time": 57.109,
        "lane": "left",
        "x": 0.32,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.135
      },
      {
        "time": 57.245,
        "lane": "right",
        "x": 0.68,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.255
      },
      {
        "time": 57.5,
        "lane": "left",
        "x": 0.44,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.255
      },
      {
        "time": 57.771,
        "lane": "right",
        "x": 0.52,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.24
      },
      {
        "time": 58.01,
        "lane": "left",
        "x": 0.52,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.24
      },
      {
        "time": 58.25,
        "lane": "right",
        "x": 0.4,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.24
      },
      {
        "time": 58.51,
        "lane": "left",
        "x": 0.66,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.411
      },
      {
        "time": 58.943,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.161
      },
      {
        "time": 59.104,
        "lane": "left",
        "x": 0.7,
        "type": "candy",
        "pitch": 80,
        "vocalDuration": 0.151
      },
      {
        "time": 59.255,
        "lane": "right",
        "x": 0.2,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.242
      },
      {
        "time": 59.497,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.242
      },
      {
        "time": 59.766,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.243
      },
      {
        "time": 60.009,
        "lane": "left",
        "x": 0.42,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.243
      },
      {
        "time": 60.252,
        "lane": "right",
        "x": 0.42,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.243
      },
      {
        "time": 60.531,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.216
      },
      {
        "time": 60.747,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.216
      },
      {
        "time": 61.005,
        "lane": "left",
        "x": 0.2,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.219
      },
      {
        "time": 61.224,
        "lane": "right",
        "x": 0.69,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.273
      },
      {
        "time": 61.497,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.273
      },
      {
        "time": 61.769,
        "lane": "right",
        "x": 0.69,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.273
      },
      {
        "time": 62.042,
        "lane": "left",
        "x": 0.45,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.273
      },
      {
        "time": 62.314,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.273
      },
      {
        "time": 62.587,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.273
      },
      {
        "time": 62.953,
        "lane": "right",
        "x": 0.43,
        "type": "fish",
        "pitch": 72,
        "vocalDuration": 0.151
      },
      {
        "time": 63.125,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.263
      },
      {
        "time": 63.388,
        "lane": "right",
        "x": 0.31,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.263
      },
      {
        "time": 63.672,
        "lane": "left",
        "x": 0.69,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.151
      },
      {
        "time": 63.839,
        "lane": "right",
        "x": 0.21,
        "type": "sushi",
        "pitch": 80,
        "vocalDuration": 0.354
      },
      {
        "time": 64.464,
        "lane": "left",
        "x": 0.58,
        "type": "iceCream",
        "pitch": 80,
        "vocalDuration": 0.25
      },
      {
        "time": 64.823,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 80,
        "vocalDuration": 0.12
      },
      {
        "time": 64.964,
        "lane": "left",
        "x": 0.46,
        "type": "donut",
        "pitch": 80,
        "vocalDuration": 0.359
      },
      {
        "time": 65.323,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.227
      },
      {
        "time": 65.549,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.227
      },
      {
        "time": 65.802,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.281
      },
      {
        "time": 66.083,
        "lane": "left",
        "x": 0.2,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.281
      },
      {
        "time": 67.016,
        "lane": "right",
        "x": 0.68,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.115
      },
      {
        "time": 67.141,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.25
      },
      {
        "time": 67.391,
        "lane": "right",
        "x": 0.69,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.25
      },
      {
        "time": 67.646,
        "lane": "left",
        "x": 0.44,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.25
      },
      {
        "time": 67.896,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.25
      },
      {
        "time": 68.146,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.25
      },
      {
        "time": 68.401,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.104
      },
      {
        "time": 68.953,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.188
      },
      {
        "time": 69.146,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.253
      },
      {
        "time": 69.398,
        "lane": "left",
        "x": 0.69,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.253
      },
      {
        "time": 69.651,
        "lane": "right",
        "x": 0.2,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.297
      },
      {
        "time": 69.948,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.068
      },
      {
        "time": 70.396,
        "lane": "right",
        "x": 0.31,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.135
      },
      {
        "time": 70.542,
        "lane": "left",
        "x": 0.44,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.052
      },
      {
        "time": 70.974,
        "lane": "right",
        "x": 0.42,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.182
      },
      {
        "time": 71.161,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.25
      },
      {
        "time": 71.438,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.24
      },
      {
        "time": 71.698,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.286
      },
      {
        "time": 72.042,
        "lane": "right",
        "x": 0.69,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.109
      },
      {
        "time": 72.151,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 80,
        "vocalDuration": 0.234
      },
      {
        "time": 72.448,
        "lane": "right",
        "x": 0.7,
        "type": "cupcake",
        "pitch": 80,
        "vocalDuration": 0.229
      },
      {
        "time": 72.677,
        "lane": "left",
        "x": 0.46,
        "type": "candy",
        "pitch": 80,
        "vocalDuration": 0.229
      },
      {
        "time": 72.974,
        "lane": "right",
        "x": 0.58,
        "type": "sushi",
        "pitch": 80,
        "vocalDuration": 0.12
      },
      {
        "time": 73.104,
        "lane": "left",
        "x": 0.59,
        "type": "iceCream",
        "pitch": 83,
        "vocalDuration": 0.193
      },
      {
        "time": 73.302,
        "lane": "right",
        "x": 0.46,
        "type": "fish",
        "pitch": 82,
        "vocalDuration": 0.188
      },
      {
        "time": 73.547,
        "lane": "left",
        "x": 0.7,
        "type": "donut",
        "pitch": 80,
        "vocalDuration": 0.25
      },
      {
        "time": 73.813,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.331
      },
      {
        "time": 74.143,
        "lane": "left",
        "x": 0.69,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.331
      },
      {
        "time": 74.661,
        "lane": "right",
        "x": 0.2,
        "type": "sushi",
        "pitch": 77,
        "vocalDuration": 0.104
      },
      {
        "time": 74.771,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.188
      },
      {
        "time": 75.161,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.245
      },
      {
        "time": 75.406,
        "lane": "left",
        "x": 0.45,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.245
      },
      {
        "time": 75.656,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.318
      },
      {
        "time": 75.979,
        "lane": "left",
        "x": 0.32,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.411
      },
      {
        "time": 76.396,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.12
      },
      {
        "time": 76.594,
        "lane": "left",
        "x": 0.2,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.313
      },
      {
        "time": 76.995,
        "lane": "right",
        "x": 0.69,
        "type": "fish",
        "pitch": 77,
        "vocalDuration": 0.13
      },
      {
        "time": 77.125,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.156
      },
      {
        "time": 77.281,
        "lane": "right",
        "x": 0.74,
        "type": "cupcake",
        "pitch": 90,
        "vocalDuration": 0.167
      },
      {
        "time": 77.453,
        "lane": "left",
        "x": 0.44,
        "type": "candy",
        "pitch": 77,
        "vocalDuration": 0.167
      },
      {
        "time": 77.625,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.241
      },
      {
        "time": 77.866,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.241
      },
      {
        "time": 78.108,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.241
      },
      {
        "time": 78.354,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.146
      },
      {
        "time": 78.516,
        "lane": "right",
        "x": 0.31,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.375
      },
      {
        "time": 78.906,
        "lane": "left",
        "x": 0.66,
        "type": "candy",
        "pitch": 70,
        "vocalDuration": 0.229
      },
      {
        "time": 79.141,
        "lane": "right",
        "x": 0.18,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.214
      },
      {
        "time": 79.359,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.224
      },
      {
        "time": 79.599,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.24
      },
      {
        "time": 79.854,
        "lane": "left",
        "x": 0.41,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.125
      },
      {
        "time": 79.979,
        "lane": "right",
        "x": 0.4,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.12
      },
      {
        "time": 80.099,
        "lane": "left",
        "x": 0.29,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.344
      },
      {
        "time": 80.474,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 80.708,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 80.964,
        "lane": "right",
        "x": 0.69,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.286
      },
      {
        "time": 81.255,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.227
      },
      {
        "time": 81.482,
        "lane": "right",
        "x": 0.68,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.227
      },
      {
        "time": 81.75,
        "lane": "left",
        "x": 0.4,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.224
      },
      {
        "time": 81.979,
        "lane": "right",
        "x": 0.52,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.234
      },
      {
        "time": 82.214,
        "lane": "left",
        "x": 0.52,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.234
      },
      {
        "time": 82.474,
        "lane": "right",
        "x": 0.42,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.237
      },
      {
        "time": 82.711,
        "lane": "left",
        "x": 0.66,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.237
      },
      {
        "time": 82.974,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.141
      },
      {
        "time": 83.12,
        "lane": "left",
        "x": 0.7,
        "type": "candy",
        "pitch": 80,
        "vocalDuration": 0.156
      },
      {
        "time": 83.281,
        "lane": "right",
        "x": 0.2,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.221
      },
      {
        "time": 83.503,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.221
      },
      {
        "time": 83.766,
        "lane": "right",
        "x": 0.31,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.083
      },
      {
        "time": 83.88,
        "lane": "left",
        "x": 0.42,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.279
      },
      {
        "time": 84.159,
        "lane": "right",
        "x": 0.42,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.279
      },
      {
        "time": 84.484,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.216
      },
      {
        "time": 84.701,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.216
      },
      {
        "time": 84.964,
        "lane": "left",
        "x": 0.22,
        "type": "iceCream",
        "pitch": 82,
        "vocalDuration": 0.146
      },
      {
        "time": 85.115,
        "lane": "right",
        "x": 0.72,
        "type": "fish",
        "pitch": 85,
        "vocalDuration": 0.146
      },
      {
        "time": 85.26,
        "lane": "left",
        "x": 0.34,
        "type": "donut",
        "pitch": 82,
        "vocalDuration": 0.267
      },
      {
        "time": 85.528,
        "lane": "right",
        "x": 0.71,
        "type": "cupcake",
        "pitch": 82,
        "vocalDuration": 0.267
      },
      {
        "time": 85.795,
        "lane": "left",
        "x": 0.46,
        "type": "candy",
        "pitch": 82,
        "vocalDuration": 0.267
      },
      {
        "time": 86.068,
        "lane": "right",
        "x": 0.59,
        "type": "sushi",
        "pitch": 83,
        "vocalDuration": 0.219
      },
      {
        "time": 86.286,
        "lane": "left",
        "x": 0.59,
        "type": "iceCream",
        "pitch": 82,
        "vocalDuration": 0.245
      },
      {
        "time": 86.531,
        "lane": "right",
        "x": 0.46,
        "type": "fish",
        "pitch": 82,
        "vocalDuration": 0.245
      },
      {
        "time": 86.781,
        "lane": "left",
        "x": 0.71,
        "type": "donut",
        "pitch": 82,
        "vocalDuration": 0.094
      },
      {
        "time": 86.875,
        "lane": "right",
        "x": 0.35,
        "type": "cupcake",
        "pitch": 83,
        "vocalDuration": 0.255
      },
      {
        "time": 87.76,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.31
      },
      {
        "time": 88.07,
        "lane": "right",
        "x": 0.17,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.31
      },
      {
        "time": 88.385,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.099
      },
      {
        "time": 88.484,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 88.716,
        "lane": "left",
        "x": 0.42,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 89,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.125
      },
      {
        "time": 89.125,
        "lane": "left",
        "x": 0.32,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.099
      },
      {
        "time": 89.229,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.237
      },
      {
        "time": 89.466,
        "lane": "left",
        "x": 0.19,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.237
      },
      {
        "time": 89.75,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.241
      },
      {
        "time": 89.991,
        "lane": "left",
        "x": 0.28,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.241
      },
      {
        "time": 90.233,
        "lane": "right",
        "x": 0.65,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.241
      },
      {
        "time": 90.536,
        "lane": "left",
        "x": 0.42,
        "type": "candy",
        "pitch": 70,
        "vocalDuration": 0.38
      },
      {
        "time": 90.953,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.156
      },
      {
        "time": 91.109,
        "lane": "left",
        "x": 0.58,
        "type": "iceCream",
        "pitch": 80,
        "vocalDuration": 0.125
      },
      {
        "time": 91.24,
        "lane": "right",
        "x": 0.45,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.25
      },
      {
        "time": 91.49,
        "lane": "left",
        "x": 0.69,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.25
      },
      {
        "time": 91.786,
        "lane": "right",
        "x": 0.3,
        "type": "cupcake",
        "pitch": 72,
        "vocalDuration": 0.104
      },
      {
        "time": 91.896,
        "lane": "left",
        "x": 0.67,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.266
      },
      {
        "time": 92.161,
        "lane": "right",
        "x": 0.18,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.266
      },
      {
        "time": 92.479,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.422
      },
      {
        "time": 92.953,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 83,
        "vocalDuration": 0.109
      },
      {
        "time": 93.078,
        "lane": "left",
        "x": 0.48,
        "type": "donut",
        "pitch": 85,
        "vocalDuration": 0.198
      },
      {
        "time": 93.276,
        "lane": "right",
        "x": 0.46,
        "type": "cupcake",
        "pitch": 82,
        "vocalDuration": 0.115
      },
      {
        "time": 93.469,
        "lane": "left",
        "x": 0.34,
        "type": "candy",
        "pitch": 82,
        "vocalDuration": 0.292
      },
      {
        "time": 93.76,
        "lane": "right",
        "x": 0.59,
        "type": "sushi",
        "pitch": 82,
        "vocalDuration": 0.292
      },
      {
        "time": 94.057,
        "lane": "left",
        "x": 0.22,
        "type": "iceCream",
        "pitch": 83,
        "vocalDuration": 0.285
      },
      {
        "time": 94.342,
        "lane": "right",
        "x": 0.71,
        "type": "fish",
        "pitch": 83,
        "vocalDuration": 0.285
      },
      {
        "time": 94.627,
        "lane": "left",
        "x": 0.35,
        "type": "donut",
        "pitch": 83,
        "vocalDuration": 0.285
      },
      {
        "time": 94.911,
        "lane": "right",
        "x": 0.71,
        "type": "cupcake",
        "pitch": 83,
        "vocalDuration": 0.094
      },
      {
        "time": 95.292,
        "lane": "left",
        "x": 0.47,
        "type": "candy",
        "pitch": 83,
        "vocalDuration": 0.083
      },
      {
        "time": 97.375,
        "lane": "right",
        "x": 0.5,
        "type": "sushi",
        "pitch": 59,
        "vocalDuration": 0.323
      },
      {
        "time": 97.698,
        "lane": "left",
        "x": 0.5,
        "type": "iceCream",
        "pitch": 59,
        "vocalDuration": 0.323
      },
      {
        "time": 98.094,
        "lane": "right",
        "x": 0.42,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.203
      },
      {
        "time": 98.302,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.193
      },
      {
        "time": 98.552,
        "lane": "right",
        "x": 0.3,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 98.786,
        "lane": "left",
        "x": 0.67,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 99.021,
        "lane": "right",
        "x": 0.18,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 99.286,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 67,
        "vocalDuration": 0.068
      },
      {
        "time": 99.354,
        "lane": "right",
        "x": 0.29,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.151
      },
      {
        "time": 99.51,
        "lane": "left",
        "x": 0.42,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.214
      },
      {
        "time": 99.724,
        "lane": "right",
        "x": 0.42,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.214
      },
      {
        "time": 100.078,
        "lane": "left",
        "x": 0.29,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.182
      },
      {
        "time": 100.26,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.25
      },
      {
        "time": 100.51,
        "lane": "left",
        "x": 0.17,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.25
      },
      {
        "time": 100.76,
        "lane": "right",
        "x": 0.66,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.25
      },
      {
        "time": 101.01,
        "lane": "left",
        "x": 0.29,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.115
      },
      {
        "time": 101.13,
        "lane": "right",
        "x": 0.65,
        "type": "cupcake",
        "pitch": 66,
        "vocalDuration": 0.146
      },
      {
        "time": 101.609,
        "lane": "left",
        "x": 0.39,
        "type": "candy",
        "pitch": 63,
        "vocalDuration": 0.302
      },
      {
        "time": 101.911,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 63,
        "vocalDuration": 0.302
      },
      {
        "time": 102.219,
        "lane": "left",
        "x": 0.52,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.151
      },
      {
        "time": 102.375,
        "lane": "right",
        "x": 0.41,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.266
      },
      {
        "time": 102.641,
        "lane": "left",
        "x": 0.65,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.266
      },
      {
        "time": 102.938,
        "lane": "right",
        "x": 0.28,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.05
      },
      {
        "time": 102.99,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.276
      },
      {
        "time": 103.266,
        "lane": "right",
        "x": 0.15,
        "type": "sushi",
        "pitch": 63,
        "vocalDuration": 0.297
      },
      {
        "time": 103.563,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 63,
        "vocalDuration": 0.297
      },
      {
        "time": 103.859,
        "lane": "right",
        "x": 0.27,
        "type": "fish",
        "pitch": 63,
        "vocalDuration": 0.297
      },
      {
        "time": 104.156,
        "lane": "left",
        "x": 0.39,
        "type": "donut",
        "pitch": 63,
        "vocalDuration": 0.297
      },
      {
        "time": 104.458,
        "lane": "right",
        "x": 0.38,
        "type": "cupcake",
        "pitch": 61,
        "vocalDuration": 0.224
      },
      {
        "time": 105.406,
        "lane": "left",
        "x": 0.25,
        "type": "candy",
        "pitch": 59,
        "vocalDuration": 0.281
      },
      {
        "time": 105.688,
        "lane": "right",
        "x": 0.5,
        "type": "sushi",
        "pitch": 59,
        "vocalDuration": 0.281
      },
      {
        "time": 106,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 106.234,
        "lane": "right",
        "x": 0.67,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.161
      },
      {
        "time": 106.469,
        "lane": "left",
        "x": 0.3,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.266
      },
      {
        "time": 106.734,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.266
      },
      {
        "time": 107,
        "lane": "left",
        "x": 0.42,
        "type": "candy",
        "pitch": 70,
        "vocalDuration": 0.245
      },
      {
        "time": 107.245,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.245
      },
      {
        "time": 107.49,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.245
      },
      {
        "time": 107.802,
        "lane": "right",
        "x": 0.41,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.146
      },
      {
        "time": 107.948,
        "lane": "left",
        "x": 0.66,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.232
      },
      {
        "time": 108.18,
        "lane": "right",
        "x": 0.3,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.232
      },
      {
        "time": 108.469,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.224
      },
      {
        "time": 108.693,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.177
      },
      {
        "time": 109.146,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 63,
        "vocalDuration": 0.255
      },
      {
        "time": 109.401,
        "lane": "right",
        "x": 0.27,
        "type": "fish",
        "pitch": 63,
        "vocalDuration": 0.255
      },
      {
        "time": 109.688,
        "lane": "left",
        "x": 0.41,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.24
      },
      {
        "time": 109.927,
        "lane": "right",
        "x": 0.41,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.24
      },
      {
        "time": 110.172,
        "lane": "left",
        "x": 0.28,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.313
      },
      {
        "time": 110.552,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 62,
        "vocalDuration": 0.177
      },
      {
        "time": 110.729,
        "lane": "left",
        "x": 0.15,
        "type": "iceCream",
        "pitch": 63,
        "vocalDuration": 0.297
      },
      {
        "time": 111.057,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.172
      },
      {
        "time": 111.234,
        "lane": "left",
        "x": 0.27,
        "type": "donut",
        "pitch": 63,
        "vocalDuration": 0.246
      },
      {
        "time": 111.48,
        "lane": "right",
        "x": 0.64,
        "type": "cupcake",
        "pitch": 63,
        "vocalDuration": 0.246
      },
      {
        "time": 111.727,
        "lane": "left",
        "x": 0.39,
        "type": "candy",
        "pitch": 63,
        "vocalDuration": 0.246
      },
      {
        "time": 111.973,
        "lane": "right",
        "x": 0.51,
        "type": "sushi",
        "pitch": 63,
        "vocalDuration": 0.246
      },
      {
        "time": 112.224,
        "lane": "left",
        "x": 0.51,
        "type": "iceCream",
        "pitch": 61,
        "vocalDuration": 0.229
      },
      {
        "time": 112.458,
        "lane": "right",
        "x": 0.39,
        "type": "fish",
        "pitch": 63,
        "vocalDuration": 0.125
      },
      {
        "time": 113.036,
        "lane": "left",
        "x": 0.64,
        "type": "donut",
        "pitch": 63,
        "vocalDuration": 0.068
      },
      {
        "time": 113.781,
        "lane": "right",
        "x": 0.29,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.125
      },
      {
        "time": 113.911,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.25
      },
      {
        "time": 114.161,
        "lane": "right",
        "x": 0.17,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.25
      },
      {
        "time": 114.438,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 114.672,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.234
      },
      {
        "time": 114.969,
        "lane": "left",
        "x": 0.44,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.12
      },
      {
        "time": 115.094,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.109
      },
      {
        "time": 115.208,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.25
      },
      {
        "time": 115.458,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.25
      },
      {
        "time": 116.458,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.242
      },
      {
        "time": 116.701,
        "lane": "right",
        "x": 0.67,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.242
      },
      {
        "time": 116.943,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.245
      },
      {
        "time": 117.188,
        "lane": "right",
        "x": 0.69,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.245
      },
      {
        "time": 117.432,
        "lane": "left",
        "x": 0.45,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.245
      },
      {
        "time": 117.693,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.276
      },
      {
        "time": 117.974,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.258
      },
      {
        "time": 118.232,
        "lane": "right",
        "x": 0.42,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.258
      },
      {
        "time": 118.505,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.417
      },
      {
        "time": 118.948,
        "lane": "right",
        "x": 0.32,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.141
      },
      {
        "time": 119.089,
        "lane": "left",
        "x": 0.69,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.214
      },
      {
        "time": 119.307,
        "lane": "right",
        "x": 0.2,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.236
      },
      {
        "time": 119.543,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.236
      },
      {
        "time": 119.78,
        "lane": "right",
        "x": 0.32,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.236
      },
      {
        "time": 120.021,
        "lane": "left",
        "x": 0.44,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.25
      },
      {
        "time": 120.271,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.25
      },
      {
        "time": 120.526,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.203
      },
      {
        "time": 121.229,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 70,
        "vocalDuration": 0.333
      },
      {
        "time": 121.568,
        "lane": "left",
        "x": 0.17,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.24
      },
      {
        "time": 121.807,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.24
      },
      {
        "time": 122.047,
        "lane": "left",
        "x": 0.29,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.24
      },
      {
        "time": 122.307,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.216
      },
      {
        "time": 122.523,
        "lane": "left",
        "x": 0.42,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.216
      },
      {
        "time": 122.792,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 74,
        "vocalDuration": 0.083
      },
      {
        "time": 122.875,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.141
      },
      {
        "time": 123.021,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.26
      },
      {
        "time": 123.281,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.26
      },
      {
        "time": 123.583,
        "lane": "right",
        "x": 0.28,
        "type": "cupcake",
        "pitch": 65,
        "vocalDuration": 0.193
      },
      {
        "time": 123.781,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.242
      },
      {
        "time": 124.023,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.242
      },
      {
        "time": 124.292,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.406
      },
      {
        "time": 124.74,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.396
      },
      {
        "time": 125.229,
        "lane": "left",
        "x": 0.45,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.245
      },
      {
        "time": 125.479,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.287
      },
      {
        "time": 125.766,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.287
      },
      {
        "time": 126.054,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.287
      },
      {
        "time": 126.341,
        "lane": "left",
        "x": 0.19,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.287
      },
      {
        "time": 126.628,
        "lane": "right",
        "x": 0.68,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.287
      },
      {
        "time": 126.916,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.287
      },
      {
        "time": 127.224,
        "lane": "right",
        "x": 0.69,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.135
      },
      {
        "time": 127.359,
        "lane": "left",
        "x": 0.45,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.24
      },
      {
        "time": 127.599,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.24
      },
      {
        "time": 127.839,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.24
      },
      {
        "time": 128.078,
        "lane": "right",
        "x": 0.45,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.24
      },
      {
        "time": 128.323,
        "lane": "left",
        "x": 0.74,
        "type": "donut",
        "pitch": 90,
        "vocalDuration": 0.276
      },
      {
        "time": 128.599,
        "lane": "right",
        "x": 0.37,
        "type": "cupcake",
        "pitch": 90,
        "vocalDuration": 0.276
      },
      {
        "time": 128.901,
        "lane": "left",
        "x": 0.71,
        "type": "candy",
        "pitch": 83,
        "vocalDuration": 0.286
      },
      {
        "time": 129.245,
        "lane": "right",
        "x": 0.22,
        "type": "sushi",
        "pitch": 83,
        "vocalDuration": 0.083
      },
      {
        "time": 129.328,
        "lane": "left",
        "x": 0.59,
        "type": "iceCream",
        "pitch": 82,
        "vocalDuration": 0.208
      },
      {
        "time": 129.542,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 80,
        "vocalDuration": 0.141
      },
      {
        "time": 129.734,
        "lane": "left",
        "x": 0.46,
        "type": "donut",
        "pitch": 80,
        "vocalDuration": 0.276
      },
      {
        "time": 130.01,
        "lane": "right",
        "x": 0.46,
        "type": "cupcake",
        "pitch": 80,
        "vocalDuration": 0.276
      },
      {
        "time": 130.286,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 80,
        "vocalDuration": 0.276
      },
      {
        "time": 130.563,
        "lane": "right",
        "x": 0.58,
        "type": "sushi",
        "pitch": 80,
        "vocalDuration": 0.276
      },
      {
        "time": 130.839,
        "lane": "left",
        "x": 0.21,
        "type": "iceCream",
        "pitch": 80,
        "vocalDuration": 0.276
      },
      {
        "time": 131.115,
        "lane": "right",
        "x": 0.7,
        "type": "fish",
        "pitch": 80,
        "vocalDuration": 0.276
      },
      {
        "time": 131.391,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.221
      },
      {
        "time": 131.612,
        "lane": "right",
        "x": 0.68,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.221
      },
      {
        "time": 131.849,
        "lane": "left",
        "x": 0.45,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.222
      },
      {
        "time": 132.071,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.222
      },
      {
        "time": 132.293,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.222
      },
      {
        "time": 132.516,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 77,
        "vocalDuration": 0.057
      },
      {
        "time": 133.026,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.12
      },
      {
        "time": 133.182,
        "lane": "right",
        "x": 0.33,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.214
      },
      {
        "time": 133.396,
        "lane": "left",
        "x": 0.69,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.214
      },
      {
        "time": 133.656,
        "lane": "right",
        "x": 0.2,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.248
      },
      {
        "time": 133.905,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.248
      },
      {
        "time": 134.153,
        "lane": "right",
        "x": 0.32,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.248
      },
      {
        "time": 134.401,
        "lane": "left",
        "x": 0.44,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.115
      },
      {
        "time": 134.708,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.167
      },
      {
        "time": 135.031,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.12
      },
      {
        "time": 135.151,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.216
      },
      {
        "time": 135.367,
        "lane": "left",
        "x": 0.2,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.216
      },
      {
        "time": 135.589,
        "lane": "right",
        "x": 0.69,
        "type": "fish",
        "pitch": 77,
        "vocalDuration": 0.083
      },
      {
        "time": 135.677,
        "lane": "left",
        "x": 0.32,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.276
      },
      {
        "time": 135.953,
        "lane": "right",
        "x": 0.69,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.276
      },
      {
        "time": 136.234,
        "lane": "left",
        "x": 0.44,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.161
      },
      {
        "time": 136.401,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.208
      },
      {
        "time": 136.964,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.161
      },
      {
        "time": 137.13,
        "lane": "right",
        "x": 0.43,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.271
      },
      {
        "time": 137.427,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.234
      },
      {
        "time": 137.677,
        "lane": "right",
        "x": 0.3,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.292
      },
      {
        "time": 138.036,
        "lane": "left",
        "x": 0.69,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.13
      },
      {
        "time": 138.172,
        "lane": "right",
        "x": 0.21,
        "type": "sushi",
        "pitch": 80,
        "vocalDuration": 0.208
      },
      {
        "time": 138.479,
        "lane": "left",
        "x": 0.58,
        "type": "iceCream",
        "pitch": 80,
        "vocalDuration": 0.276
      },
      {
        "time": 138.964,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 80,
        "vocalDuration": 0.141
      },
      {
        "time": 139.141,
        "lane": "left",
        "x": 0.47,
        "type": "donut",
        "pitch": 83,
        "vocalDuration": 0.172
      },
      {
        "time": 139.313,
        "lane": "right",
        "x": 0.46,
        "type": "cupcake",
        "pitch": 82,
        "vocalDuration": 0.177
      },
      {
        "time": 139.495,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 80,
        "vocalDuration": 0.255
      },
      {
        "time": 139.828,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.268
      },
      {
        "time": 140.096,
        "lane": "left",
        "x": 0.2,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.268
      },
      {
        "time": 140.745,
        "lane": "right",
        "x": 0.69,
        "type": "fish",
        "pitch": 77,
        "vocalDuration": 0.177
      },
      {
        "time": 141.172,
        "lane": "left",
        "x": 0.33,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.313
      },
      {
        "time": 141.484,
        "lane": "right",
        "x": 0.74,
        "type": "cupcake",
        "pitch": 90,
        "vocalDuration": 0.182
      },
      {
        "time": 141.667,
        "lane": "left",
        "x": 0.44,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.135
      },
      {
        "time": 141.807,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 76,
        "vocalDuration": 0.305
      },
      {
        "time": 142.112,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 76,
        "vocalDuration": 0.305
      },
      {
        "time": 142.417,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.104
      },
      {
        "time": 142.656,
        "lane": "left",
        "x": 0.69,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.198
      },
      {
        "time": 143.016,
        "lane": "right",
        "x": 0.32,
        "type": "cupcake",
        "pitch": 77,
        "vocalDuration": 0.115
      },
      {
        "time": 143.13,
        "lane": "left",
        "x": 0.74,
        "type": "candy",
        "pitch": 90,
        "vocalDuration": 0.161
      },
      {
        "time": 143.292,
        "lane": "right",
        "x": 0.2,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.167
      },
      {
        "time": 143.458,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 77,
        "vocalDuration": 0.188
      },
      {
        "time": 143.651,
        "lane": "right",
        "x": 0.32,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.277
      },
      {
        "time": 143.928,
        "lane": "left",
        "x": 0.44,
        "type": "donut",
        "pitch": 76,
        "vocalDuration": 0.277
      },
      {
        "time": 144.206,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.277
      },
      {
        "time": 144.483,
        "lane": "left",
        "x": 0.32,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.277
      },
      {
        "time": 144.76,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.094
      },
      {
        "time": 144.922,
        "lane": "left",
        "x": 0.17,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.214
      },
      {
        "time": 145.141,
        "lane": "right",
        "x": 0.67,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.224
      },
      {
        "time": 145.37,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.234
      },
      {
        "time": 145.635,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.224
      },
      {
        "time": 145.865,
        "lane": "left",
        "x": 0.41,
        "type": "candy",
        "pitch": 68,
        "vocalDuration": 0.12
      },
      {
        "time": 145.99,
        "lane": "right",
        "x": 0.52,
        "type": "sushi",
        "pitch": 64,
        "vocalDuration": 0.104
      },
      {
        "time": 146.099,
        "lane": "left",
        "x": 0.53,
        "type": "iceCream",
        "pitch": 68,
        "vocalDuration": 0.359
      },
      {
        "time": 146.484,
        "lane": "right",
        "x": 0.42,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 146.721,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.237
      },
      {
        "time": 146.995,
        "lane": "right",
        "x": 0.32,
        "type": "cupcake",
        "pitch": 76,
        "vocalDuration": 0.271
      },
      {
        "time": 147.266,
        "lane": "left",
        "x": 0.68,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.227
      },
      {
        "time": 147.492,
        "lane": "right",
        "x": 0.19,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.227
      },
      {
        "time": 147.729,
        "lane": "left",
        "x": 0.52,
        "type": "iceCream",
        "pitch": 65,
        "vocalDuration": 0.26
      },
      {
        "time": 147.995,
        "lane": "right",
        "x": 0.28,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.24
      },
      {
        "time": 148.234,
        "lane": "left",
        "x": 0.4,
        "type": "donut",
        "pitch": 66,
        "vocalDuration": 0.24
      },
      {
        "time": 148.474,
        "lane": "right",
        "x": 0.42,
        "type": "cupcake",
        "pitch": 70,
        "vocalDuration": 0.391
      },
      {
        "time": 148.969,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.151
      },
      {
        "time": 149.125,
        "lane": "right",
        "x": 0.58,
        "type": "sushi",
        "pitch": 80,
        "vocalDuration": 0.151
      },
      {
        "time": 149.281,
        "lane": "left",
        "x": 0.2,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.13
      },
      {
        "time": 149.484,
        "lane": "right",
        "x": 0.69,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.234
      },
      {
        "time": 149.766,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.094
      },
      {
        "time": 149.885,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.279
      },
      {
        "time": 150.164,
        "lane": "left",
        "x": 0.42,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.279
      },
      {
        "time": 150.458,
        "lane": "right",
        "x": 0.56,
        "type": "sushi",
        "pitch": 75,
        "vocalDuration": 0.232
      },
      {
        "time": 150.69,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.232
      },
      {
        "time": 150.969,
        "lane": "right",
        "x": 0.46,
        "type": "fish",
        "pitch": 82,
        "vocalDuration": 0.125
      },
      {
        "time": 151.125,
        "lane": "left",
        "x": 0.72,
        "type": "donut",
        "pitch": 85,
        "vocalDuration": 0.13
      },
      {
        "time": 151.271,
        "lane": "right",
        "x": 0.34,
        "type": "cupcake",
        "pitch": 82,
        "vocalDuration": 0.271
      },
      {
        "time": 151.542,
        "lane": "left",
        "x": 0.71,
        "type": "candy",
        "pitch": 82,
        "vocalDuration": 0.271
      },
      {
        "time": 151.813,
        "lane": "right",
        "x": 0.22,
        "type": "sushi",
        "pitch": 82,
        "vocalDuration": 0.271
      },
      {
        "time": 152.089,
        "lane": "left",
        "x": 0.59,
        "type": "iceCream",
        "pitch": 83,
        "vocalDuration": 0.271
      },
      {
        "time": 152.359,
        "lane": "right",
        "x": 0.35,
        "type": "fish",
        "pitch": 83,
        "vocalDuration": 0.271
      },
      {
        "time": 152.63,
        "lane": "left",
        "x": 0.41,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.167
      },
      {
        "time": 152.797,
        "lane": "right",
        "x": 0.47,
        "type": "cupcake",
        "pitch": 83,
        "vocalDuration": 0.063
      },
      {
        "time": 152.896,
        "lane": "left",
        "x": 0.35,
        "type": "candy",
        "pitch": 83,
        "vocalDuration": 0.161
      },
      {
        "time": 153.057,
        "lane": "right",
        "x": 0.59,
        "type": "sushi",
        "pitch": 83,
        "vocalDuration": 0.323
      },
      {
        "time": 153.417,
        "lane": "left",
        "x": 0.17,
        "type": "iceCream",
        "pitch": 70,
        "vocalDuration": 0.328
      },
      {
        "time": 153.745,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.326
      },
      {
        "time": 154.07,
        "lane": "left",
        "x": 0.29,
        "type": "donut",
        "pitch": 68,
        "vocalDuration": 0.326
      },
      {
        "time": 154.401,
        "lane": "right",
        "x": 0.65,
        "type": "cupcake",
        "pitch": 68,
        "vocalDuration": 0.089
      },
      {
        "time": 154.521,
        "lane": "left",
        "x": 0.42,
        "type": "candy",
        "pitch": 71,
        "vocalDuration": 0.227
      },
      {
        "time": 154.747,
        "lane": "right",
        "x": 0.54,
        "type": "sushi",
        "pitch": 71,
        "vocalDuration": 0.227
      },
      {
        "time": 155.031,
        "lane": "left",
        "x": 0.56,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.094
      },
      {
        "time": 155.13,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 76,
        "vocalDuration": 0.13
      },
      {
        "time": 155.266,
        "lane": "left",
        "x": 0.68,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.24
      },
      {
        "time": 155.505,
        "lane": "right",
        "x": 0.31,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.24
      },
      {
        "time": 155.766,
        "lane": "left",
        "x": 0.65,
        "type": "candy",
        "pitch": 66,
        "vocalDuration": 0.247
      },
      {
        "time": 156.012,
        "lane": "right",
        "x": 0.16,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.247
      },
      {
        "time": 156.259,
        "lane": "left",
        "x": 0.52,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.247
      },
      {
        "time": 156.536,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 70,
        "vocalDuration": 0.396
      },
      {
        "time": 156.958,
        "lane": "left",
        "x": 0.45,
        "type": "donut",
        "pitch": 78,
        "vocalDuration": 0.182
      },
      {
        "time": 157.146,
        "lane": "right",
        "x": 0.46,
        "type": "cupcake",
        "pitch": 80,
        "vocalDuration": 0.125
      },
      {
        "time": 157.276,
        "lane": "left",
        "x": 0.33,
        "type": "candy",
        "pitch": 78,
        "vocalDuration": 0.094
      },
      {
        "time": 157.458,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.286
      },
      {
        "time": 157.781,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 72,
        "vocalDuration": 0.109
      },
      {
        "time": 157.896,
        "lane": "right",
        "x": 0.62,
        "type": "fish",
        "pitch": 59,
        "vocalDuration": 0.237
      },
      {
        "time": 158.133,
        "lane": "left",
        "x": 0.25,
        "type": "donut",
        "pitch": 59,
        "vocalDuration": 0.237
      },
      {
        "time": 158.469,
        "lane": "right",
        "x": 0.68,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.219
      },
      {
        "time": 158.688,
        "lane": "left",
        "x": 0.44,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.219
      },
      {
        "time": 158.958,
        "lane": "right",
        "x": 0.59,
        "type": "sushi",
        "pitch": 84,
        "vocalDuration": 0.318
      },
      {
        "time": 159.276,
        "lane": "left",
        "x": 0.59,
        "type": "iceCream",
        "pitch": 82,
        "vocalDuration": 0.269
      },
      {
        "time": 159.545,
        "lane": "right",
        "x": 0.46,
        "type": "fish",
        "pitch": 82,
        "vocalDuration": 0.269
      },
      {
        "time": 159.814,
        "lane": "left",
        "x": 0.71,
        "type": "donut",
        "pitch": 82,
        "vocalDuration": 0.269
      },
      {
        "time": 160.089,
        "lane": "right",
        "x": 0.35,
        "type": "cupcake",
        "pitch": 83,
        "vocalDuration": 0.286
      },
      {
        "time": 160.375,
        "lane": "left",
        "x": 0.71,
        "type": "candy",
        "pitch": 83,
        "vocalDuration": 0.286
      },
      {
        "time": 160.661,
        "lane": "right",
        "x": 0.22,
        "type": "sushi",
        "pitch": 83,
        "vocalDuration": 0.286
      },
      {
        "time": 161.021,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.266
      },
      {
        "time": 161.286,
        "lane": "right",
        "x": 0.33,
        "type": "fish",
        "pitch": 78,
        "vocalDuration": 0.266
      },
      {
        "time": 161.552,
        "lane": "left",
        "x": 0.43,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.269
      },
      {
        "time": 161.821,
        "lane": "right",
        "x": 0.43,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.269
      },
      {
        "time": 162.089,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.269
      },
      {
        "time": 162.358,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.269
      },
      {
        "time": 162.626,
        "lane": "left",
        "x": 0.18,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.269
      },
      {
        "time": 162.895,
        "lane": "right",
        "x": 0.67,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.269
      },
      {
        "time": 163.164,
        "lane": "left",
        "x": 0.31,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.269
      },
      {
        "time": 163.432,
        "lane": "right",
        "x": 0.68,
        "type": "cupcake",
        "pitch": 74,
        "vocalDuration": 0.313
      },
      {
        "time": 163.979,
        "lane": "left",
        "x": 0.44,
        "type": "candy",
        "pitch": 76,
        "vocalDuration": 0.083
      },
      {
        "time": 164.063,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.281
      },
      {
        "time": 164.344,
        "lane": "left",
        "x": 0.55,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.281
      },
      {
        "time": 164.625,
        "lane": "right",
        "x": 0.43,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.281
      },
      {
        "time": 164.906,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.281
      },
      {
        "time": 165.224,
        "lane": "right",
        "x": 0.31,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.302
      },
      {
        "time": 165.531,
        "lane": "left",
        "x": 0.67,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.208
      },
      {
        "time": 165.745,
        "lane": "right",
        "x": 0.18,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.167
      },
      {
        "time": 166.026,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.182
      },
      {
        "time": 166.214,
        "lane": "right",
        "x": 0.31,
        "type": "fish",
        "pitch": 73,
        "vocalDuration": 0.266
      },
      {
        "time": 166.479,
        "lane": "left",
        "x": 0.43,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.266
      },
      {
        "time": 166.745,
        "lane": "right",
        "x": 0.43,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.266
      },
      {
        "time": 167.01,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.266
      },
      {
        "time": 167.276,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.266
      },
      {
        "time": 167.563,
        "lane": "left",
        "x": 0.19,
        "type": "iceCream",
        "pitch": 75,
        "vocalDuration": 0.12
      },
      {
        "time": 167.781,
        "lane": "right",
        "x": 0.67,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.214
      },
      {
        "time": 167.995,
        "lane": "left",
        "x": 0.3,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.214
      },
      {
        "time": 168.214,
        "lane": "right",
        "x": 0.67,
        "type": "cupcake",
        "pitch": 73,
        "vocalDuration": 0.299
      },
      {
        "time": 168.512,
        "lane": "left",
        "x": 0.43,
        "type": "candy",
        "pitch": 73,
        "vocalDuration": 0.299
      },
      {
        "time": 168.811,
        "lane": "right",
        "x": 0.55,
        "type": "sushi",
        "pitch": 73,
        "vocalDuration": 0.299
      },
      {
        "time": 169.214,
        "lane": "left",
        "x": 0.55,
        "type": "iceCream",
        "pitch": 73,
        "vocalDuration": 0.099
      },
      {
        "time": 169.37,
        "lane": "right",
        "x": 0.44,
        "type": "fish",
        "pitch": 75,
        "vocalDuration": 0.151
      },
      {
        "time": 169.521,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 73,
        "vocalDuration": 0.297
      },
      {
        "time": 169.823,
        "lane": "right",
        "x": 0.3,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.094
      },
      {
        "time": 170.026,
        "lane": "left",
        "x": 0.64,
        "type": "candy",
        "pitch": 65,
        "vocalDuration": 0.151
      },
      {
        "time": 170.182,
        "lane": "right",
        "x": 0.17,
        "type": "sushi",
        "pitch": 68,
        "vocalDuration": 0.318
      },
      {
        "time": 170.505,
        "lane": "left",
        "x": 0.54,
        "type": "iceCream",
        "pitch": 71,
        "vocalDuration": 0.247
      },
      {
        "time": 170.753,
        "lane": "right",
        "x": 0.3,
        "type": "fish",
        "pitch": 71,
        "vocalDuration": 0.247
      },
      {
        "time": 171.031,
        "lane": "left",
        "x": 0.44,
        "type": "donut",
        "pitch": 75,
        "vocalDuration": 0.253
      },
      {
        "time": 171.285,
        "lane": "right",
        "x": 0.44,
        "type": "cupcake",
        "pitch": 75,
        "vocalDuration": 0.253
      },
      {
        "time": 171.538,
        "lane": "left",
        "x": 0.31,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.253
      },
      {
        "time": 171.839,
        "lane": "right",
        "x": 0.52,
        "type": "sushi",
        "pitch": 66,
        "vocalDuration": 0.224
      },
      {
        "time": 172.063,
        "lane": "left",
        "x": 0.16,
        "type": "iceCream",
        "pitch": 66,
        "vocalDuration": 0.224
      },
      {
        "time": 172.286,
        "lane": "right",
        "x": 0.65,
        "type": "fish",
        "pitch": 66,
        "vocalDuration": 0.224
      },
      {
        "time": 172.547,
        "lane": "left",
        "x": 0.3,
        "type": "donut",
        "pitch": 70,
        "vocalDuration": 0.422
      },
      {
        "time": 173.042,
        "lane": "right",
        "x": 0.69,
        "type": "cupcake",
        "pitch": 78,
        "vocalDuration": 0.094
      },
      {
        "time": 173.141,
        "lane": "left",
        "x": 0.46,
        "type": "candy",
        "pitch": 80,
        "vocalDuration": 0.156
      },
      {
        "time": 173.297,
        "lane": "right",
        "x": 0.57,
        "type": "sushi",
        "pitch": 78,
        "vocalDuration": 0.232
      },
      {
        "time": 173.529,
        "lane": "left",
        "x": 0.57,
        "type": "iceCream",
        "pitch": 78,
        "vocalDuration": 0.232
      },
      {
        "time": 173.958,
        "lane": "right",
        "x": 0.41,
        "type": "fish",
        "pitch": 68,
        "vocalDuration": 0.057
      },
      {
        "time": 174.063,
        "lane": "left",
        "x": 0.67,
        "type": "donut",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 174.294,
        "lane": "right",
        "x": 0.3,
        "type": "cupcake",
        "pitch": 71,
        "vocalDuration": 0.232
      },
      {
        "time": 174.609,
        "lane": "left",
        "x": 0.68,
        "type": "candy",
        "pitch": 75,
        "vocalDuration": 0.391
      },
      {
        "time": 175.031,
        "lane": "right",
        "x": 0.23,
        "type": "sushi",
        "pitch": 84,
        "vocalDuration": 0.302
      },
      {
        "time": 175.344,
        "lane": "left",
        "x": 0.59,
        "type": "iceCream",
        "pitch": 82,
        "vocalDuration": 0.264
      },
      {
        "time": 175.608,
        "lane": "right",
        "x": 0.34,
        "type": "fish",
        "pitch": 82,
        "vocalDuration": 0.264
      },
      {
        "time": 175.872,
        "lane": "left",
        "x": 0.46,
        "type": "donut",
        "pitch": 82,
        "vocalDuration": 0.264
      },
      {
        "time": 176.141,
        "lane": "right",
        "x": 0.47,
        "type": "cupcake",
        "pitch": 83,
        "vocalDuration": 0.269
      },
      {
        "time": 176.41,
        "lane": "left",
        "x": 0.35,
        "type": "candy",
        "pitch": 83,
        "vocalDuration": 0.269
      },
      {
        "time": 176.679,
        "lane": "right",
        "x": 0.59,
        "type": "sushi",
        "pitch": 83,
        "vocalDuration": 0.269
      },
      {
        "time": 176.953,
        "lane": "left",
        "x": 0.22,
        "type": "iceCream",
        "pitch": 82,
        "vocalDuration": 0.295
      },
      {
        "time": 177.248,
        "lane": "right",
        "x": 0.71,
        "type": "fish",
        "pitch": 82,
        "vocalDuration": 0.295
      },
      {
        "time": 177.543,
        "lane": "left",
        "x": 0.34,
        "type": "donut",
        "pitch": 82,
        "vocalDuration": 0.295
      },
      {
        "time": 177.875,
        "lane": "right",
        "x": 0.71,
        "type": "cupcake",
        "pitch": 83,
        "vocalDuration": 0.052
      }
    ]
  },
  "difficultyCharts": {
    "easy": {
      "noteTravelTime": 1.9,
      "notes": [
        {
          "time": 10.823,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 38,
          "vocalDuration": 0.094
        },
        {
          "time": 16.276,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 62,
          "vocalDuration": 0.068
        },
        {
          "time": 16.438,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.198
        },
        {
          "time": 16.635,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 62,
          "vocalDuration": 0.141
        },
        {
          "time": 16.776,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.219
        },
        {
          "time": 16.995,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.219
        },
        {
          "time": 17.214,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 61,
          "vocalDuration": 0.266
        },
        {
          "time": 17.479,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 60,
          "vocalDuration": 0.146
        },
        {
          "time": 17.63,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 61,
          "vocalDuration": 0.172
        },
        {
          "time": 17.802,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.286
        },
        {
          "time": 18.089,
          "lane": "left",
          "x": 0.54,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.286
        },
        {
          "time": 18.375,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.167
        },
        {
          "time": 18.583,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.115
        },
        {
          "time": 18.781,
          "lane": "right",
          "x": 0.24,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.401
        },
        {
          "time": 19.214,
          "lane": "left",
          "x": 0.71,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.38
        },
        {
          "time": 19.62,
          "lane": "right",
          "x": 0.13,
          "type": "cupcake",
          "pitch": 59,
          "vocalDuration": 0.333
        },
        {
          "time": 19.964,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.237
        },
        {
          "time": 20.201,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.237
        },
        {
          "time": 20.682,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 20.905,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 21.127,
          "lane": "left",
          "x": 0.47,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 21.641,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 21.908,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.174,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.441,
          "lane": "left",
          "x": 0.28,
          "type": "iceCream",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.714,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 58,
          "vocalDuration": 0.172
        },
        {
          "time": 22.891,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.242
        },
        {
          "time": 23.133,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.242
        },
        {
          "time": 23.375,
          "lane": "left",
          "x": 0.17,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.396
        },
        {
          "time": 23.776,
          "lane": "right",
          "x": 0.73,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 24.008,
          "lane": "left",
          "x": 0.26,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 24.406,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 59,
          "vocalDuration": 0.208
        },
        {
          "time": 24.62,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.318
        },
        {
          "time": 24.938,
          "lane": "right",
          "x": 0.54,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.318
        },
        {
          "time": 25.26,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.203
        },
        {
          "time": 25.469,
          "lane": "right",
          "x": 0.45,
          "type": "sushi",
          "pitch": 60,
          "vocalDuration": 0.146
        },
        {
          "time": 25.62,
          "lane": "left",
          "x": 0.46,
          "type": "iceCream",
          "pitch": 62,
          "vocalDuration": 0.177
        },
        {
          "time": 25.797,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 26.052,
          "lane": "left",
          "x": 0.54,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 26.313,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 61,
          "vocalDuration": 0.375
        },
        {
          "time": 26.766,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.198
        },
        {
          "time": 27.411,
          "lane": "right",
          "x": 0.23,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.068
        },
        {
          "time": 27.635,
          "lane": "left",
          "x": 0.73,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.339
        },
        {
          "time": 27.974,
          "lane": "right",
          "x": 0.14,
          "type": "fish",
          "pitch": 61,
          "vocalDuration": 0.365
        },
        {
          "time": 28.474,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 61,
          "vocalDuration": 0.109
        },
        {
          "time": 28.792,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 29.057,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 29.323,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 29.594,
          "lane": "left",
          "x": 0.48,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.234
        },
        {
          "time": 29.828,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.208
        },
        {
          "time": 30.036,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 30.26,
          "lane": "right",
          "x": 0.48,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 30.49,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.141
        },
        {
          "time": 30.813,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.063,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.313,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.766,
          "lane": "left",
          "x": 0.18,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.234
        },
        {
          "time": 32.266,
          "lane": "right",
          "x": 0.73,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 32.76,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 32.987,
          "lane": "right",
          "x": 0.66,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 33.281,
          "lane": "left",
          "x": 0.31,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 33.51,
          "lane": "right",
          "x": 0.55,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 33.755,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.323
        },
        {
          "time": 34.25,
          "lane": "right",
          "x": 0.5,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 34.5,
          "lane": "left",
          "x": 0.5,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 34.766,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 35.031,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 35.474,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.359
        },
        {
          "time": 36.016,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.272,
          "lane": "right",
          "x": 0.26,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.529,
          "lane": "left",
          "x": 0.73,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.785,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 37.047,
          "lane": "left",
          "x": 0.65,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.078
        },
        {
          "time": 37.13,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.414,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.698,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.982,
          "lane": "left",
          "x": 0.5,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 38.276,
          "lane": "right",
          "x": 0.43,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.411
        },
        {
          "time": 38.698,
          "lane": "left",
          "x": 0.43,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.271
        },
        {
          "time": 39.281,
          "lane": "right",
          "x": 0.47,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.219
        },
        {
          "time": 39.5,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.219
        },
        {
          "time": 39.745,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.219
        },
        {
          "time": 39.974,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.104
        },
        {
          "time": 40.24,
          "lane": "right",
          "x": 0.66,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.234
        },
        {
          "time": 40.552,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.167
        },
        {
          "time": 40.766,
          "lane": "right",
          "x": 0.73,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.247
        },
        {
          "time": 41.013,
          "lane": "left",
          "x": 0.26,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.247
        },
        {
          "time": 41.292,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.232
        },
        {
          "time": 41.523,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.232
        },
        {
          "time": 41.776,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.214
        },
        {
          "time": 42.276,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.286
        },
        {
          "time": 42.755,
          "lane": "right",
          "x": 0.5,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.276
        },
        {
          "time": 43.042,
          "lane": "left",
          "x": 0.51,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.208
        },
        {
          "time": 43.281,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.115
        },
        {
          "time": 43.521,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.37
        },
        {
          "time": 43.974,
          "lane": "right",
          "x": 0.34,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.328,
          "lane": "left",
          "x": 0.66,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 44.693,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 44.964,
          "lane": "left",
          "x": 0.73,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 45.286,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.057
        },
        {
          "time": 45.344,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.307
        },
        {
          "time": 45.656,
          "lane": "right",
          "x": 0.25,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 45.948,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.094
        },
        {
          "time": 46.047,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.141
        },
        {
          "time": 46.469,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 46.745,
          "lane": "left",
          "x": 0.48,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.021,
          "lane": "right",
          "x": 0.48,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.297,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.573,
          "lane": "right",
          "x": 0.56,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.943,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 48.214,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 48.49,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.245
        },
        {
          "time": 48.734,
          "lane": "right",
          "x": 0.73,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.245
        },
        {
          "time": 49.01,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.26,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.51,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.813,
          "lane": "right",
          "x": 0.55,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.036,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.26,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.49,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.135
        },
        {
          "time": 50.63,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.286
        },
        {
          "time": 50.964,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.125
        },
        {
          "time": 51.094,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.161
        },
        {
          "time": 51.492,
          "lane": "right",
          "x": 0.28,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 51.75,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 51.988,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 52.226,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 52.484,
          "lane": "right",
          "x": 0.26,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 52.727,
          "lane": "left",
          "x": 0.73,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 52.995,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 53.141,
          "lane": "left",
          "x": 0.68,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.193
        },
        {
          "time": 53.333,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 53.58,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 53.826,
          "lane": "right",
          "x": 0.51,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 54.073,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 54.378,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 54.684,
          "lane": "left",
          "x": 0.43,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 55.5,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.219
        },
        {
          "time": 55.724,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 55.976,
          "lane": "right",
          "x": 0.72,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 56.227,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 56.49,
          "lane": "right",
          "x": 0.65,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 56.721,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 56.984,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.12
        },
        {
          "time": 57.109,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 57.5,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.255
        },
        {
          "time": 57.771,
          "lane": "right",
          "x": 0.47,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.01,
          "lane": "left",
          "x": 0.39,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.25,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.51,
          "lane": "left",
          "x": 0.49,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.411
        },
        {
          "time": 58.943,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.161
        },
        {
          "time": 59.104,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.151
        },
        {
          "time": 59.497,
          "lane": "left",
          "x": 0.68,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.242
        },
        {
          "time": 59.766,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.009,
          "lane": "left",
          "x": 0.72,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.252,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.531,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.216
        },
        {
          "time": 60.747,
          "lane": "right",
          "x": 0.26,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.216
        },
        {
          "time": 61.005,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.219
        },
        {
          "time": 61.224,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 61.497,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 61.769,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.042,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.314,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.587,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.953,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.151
        },
        {
          "time": 63.125,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.263
        },
        {
          "time": 63.388,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.263
        },
        {
          "time": 63.672,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.151
        },
        {
          "time": 63.839,
          "lane": "right",
          "x": 0.76,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.354
        },
        {
          "time": 64.464,
          "lane": "left",
          "x": 0.29,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.25
        },
        {
          "time": 64.823,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.12
        },
        {
          "time": 64.964,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.359
        },
        {
          "time": 65.323,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 65.549,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 65.802,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.281
        },
        {
          "time": 66.083,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.281
        },
        {
          "time": 67.016,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.115
        },
        {
          "time": 67.141,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 67.391,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 67.646,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 67.896,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 68.146,
          "lane": "left",
          "x": 0.75,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 68.401,
          "lane": "right",
          "x": 0.19,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.104
        },
        {
          "time": 68.953,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.188
        },
        {
          "time": 69.146,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.253
        },
        {
          "time": 69.398,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.253
        },
        {
          "time": 69.651,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.297
        },
        {
          "time": 69.948,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.068
        },
        {
          "time": 70.396,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.135
        },
        {
          "time": 70.542,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.052
        },
        {
          "time": 70.974,
          "lane": "right",
          "x": 0.49,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.182
        },
        {
          "time": 71.161,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 71.438,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 71.698,
          "lane": "left",
          "x": 0.26,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.286
        },
        {
          "time": 72.042,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.109
        },
        {
          "time": 72.151,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.234
        },
        {
          "time": 72.448,
          "lane": "right",
          "x": 0.76,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.229
        },
        {
          "time": 72.677,
          "lane": "left",
          "x": 0.29,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.229
        },
        {
          "time": 72.974,
          "lane": "right",
          "x": 0.68,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.12
        },
        {
          "time": 73.104,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.193
        },
        {
          "time": 73.302,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.188
        },
        {
          "time": 73.547,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.25
        },
        {
          "time": 73.813,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.331
        },
        {
          "time": 74.143,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.331
        },
        {
          "time": 74.661,
          "lane": "right",
          "x": 0.44,
          "type": "sushi",
          "pitch": 77,
          "vocalDuration": 0.104
        },
        {
          "time": 74.771,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.188
        },
        {
          "time": 75.161,
          "lane": "right",
          "x": 0.36,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 75.406,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 75.656,
          "lane": "right",
          "x": 0.27,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.318
        },
        {
          "time": 75.979,
          "lane": "left",
          "x": 0.75,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.411
        },
        {
          "time": 76.396,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 76.594,
          "lane": "left",
          "x": 0.67,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.313
        },
        {
          "time": 76.995,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.13
        },
        {
          "time": 77.125,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 77.453,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 77,
          "vocalDuration": 0.167
        },
        {
          "time": 77.625,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 77.866,
          "lane": "left",
          "x": 0.43,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 78.108,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 78.354,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.146
        },
        {
          "time": 78.516,
          "lane": "right",
          "x": 0.51,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.375
        },
        {
          "time": 78.906,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.229
        },
        {
          "time": 79.141,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.214
        },
        {
          "time": 79.359,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.224
        },
        {
          "time": 79.599,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 79.854,
          "lane": "left",
          "x": 0.24,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 79.979,
          "lane": "right",
          "x": 0.7,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.12
        },
        {
          "time": 80.474,
          "lane": "right",
          "x": 0.65,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 80.708,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 80.964,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 81.255,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 81.482,
          "lane": "right",
          "x": 0.51,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 81.75,
          "lane": "left",
          "x": 0.47,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.224
        },
        {
          "time": 81.979,
          "lane": "right",
          "x": 0.39,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 82.214,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 82.474,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.237
        },
        {
          "time": 82.711,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.237
        },
        {
          "time": 82.974,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.141
        },
        {
          "time": 83.12,
          "lane": "left",
          "x": 0.76,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.156
        },
        {
          "time": 83.503,
          "lane": "left",
          "x": 0.68,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.221
        },
        {
          "time": 83.766,
          "lane": "right",
          "x": 0.18,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.083
        },
        {
          "time": 83.88,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 84.159,
          "lane": "right",
          "x": 0.26,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 84.484,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.216
        },
        {
          "time": 84.701,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.216
        },
        {
          "time": 84.964,
          "lane": "left",
          "x": 0.45,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.146
        },
        {
          "time": 85.115,
          "lane": "right",
          "x": 0.47,
          "type": "fish",
          "pitch": 85,
          "vocalDuration": 0.146
        },
        {
          "time": 85.528,
          "lane": "right",
          "x": 0.53,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 85.795,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 86.068,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.219
        },
        {
          "time": 86.286,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.245
        },
        {
          "time": 86.531,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.245
        },
        {
          "time": 86.781,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.094
        },
        {
          "time": 86.875,
          "lane": "right",
          "x": 0.77,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.255
        },
        {
          "time": 87.76,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.31
        },
        {
          "time": 88.07,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.31
        },
        {
          "time": 88.385,
          "lane": "left",
          "x": 0.32,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.099
        },
        {
          "time": 88.484,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 88.716,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 89,
          "lane": "right",
          "x": 0.51,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.125
        },
        {
          "time": 89.125,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.099
        },
        {
          "time": 89.466,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.237
        },
        {
          "time": 89.75,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 89.991,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 90.233,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 90.536,
          "lane": "left",
          "x": 0.72,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.38
        },
        {
          "time": 90.953,
          "lane": "right",
          "x": 0.28,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 91.109,
          "lane": "left",
          "x": 0.68,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.125
        },
        {
          "time": 91.49,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 91.786,
          "lane": "right",
          "x": 0.18,
          "type": "cupcake",
          "pitch": 72,
          "vocalDuration": 0.104
        },
        {
          "time": 91.896,
          "lane": "left",
          "x": 0.49,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 92.161,
          "lane": "right",
          "x": 0.26,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 92.479,
          "lane": "left",
          "x": 0.43,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.422
        },
        {
          "time": 92.953,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.109
        },
        {
          "time": 93.078,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 85,
          "vocalDuration": 0.198
        },
        {
          "time": 93.276,
          "lane": "right",
          "x": 0.45,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.115
        },
        {
          "time": 93.469,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.292
        },
        {
          "time": 93.76,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 82,
          "vocalDuration": 0.292
        },
        {
          "time": 94.057,
          "lane": "left",
          "x": 0.22,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.342,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.627,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.911,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.094
        },
        {
          "time": 95.292,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.083
        },
        {
          "time": 97.375,
          "lane": "right",
          "x": 0.68,
          "type": "sushi",
          "pitch": 59,
          "vocalDuration": 0.323
        },
        {
          "time": 97.698,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 59,
          "vocalDuration": 0.323
        },
        {
          "time": 98.094,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.203
        },
        {
          "time": 98.302,
          "lane": "left",
          "x": 0.5,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.193
        },
        {
          "time": 98.552,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 98.786,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 99.021,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 99.286,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.068
        },
        {
          "time": 99.354,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.151
        },
        {
          "time": 99.724,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 100.078,
          "lane": "left",
          "x": 0.72,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.182
        },
        {
          "time": 100.26,
          "lane": "right",
          "x": 0.25,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 100.51,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 100.76,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 101.01,
          "lane": "left",
          "x": 0.56,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.115
        },
        {
          "time": 101.13,
          "lane": "right",
          "x": 0.24,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.146
        },
        {
          "time": 101.609,
          "lane": "left",
          "x": 0.46,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.302
        },
        {
          "time": 101.911,
          "lane": "right",
          "x": 0.3,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.302
        },
        {
          "time": 102.219,
          "lane": "left",
          "x": 0.39,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.151
        },
        {
          "time": 102.375,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 102.641,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 102.938,
          "lane": "right",
          "x": 0.47,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.05
        },
        {
          "time": 102.99,
          "lane": "left",
          "x": 0.24,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.276
        },
        {
          "time": 103.266,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 103.563,
          "lane": "left",
          "x": 0.15,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 103.859,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 104.156,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 104.458,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 61,
          "vocalDuration": 0.224
        },
        {
          "time": 105.406,
          "lane": "left",
          "x": 0.29,
          "type": "candy",
          "pitch": 59,
          "vocalDuration": 0.281
        },
        {
          "time": 105.688,
          "lane": "right",
          "x": 0.6,
          "type": "sushi",
          "pitch": 59,
          "vocalDuration": 0.281
        },
        {
          "time": 106,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 106.234,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.161
        },
        {
          "time": 106.469,
          "lane": "left",
          "x": 0.49,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 106.734,
          "lane": "right",
          "x": 0.49,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 107,
          "lane": "left",
          "x": 0.57,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.245,
          "lane": "right",
          "x": 0.41,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.49,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.802,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.146
        },
        {
          "time": 107.948,
          "lane": "left",
          "x": 0.72,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.232
        },
        {
          "time": 108.18,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.232
        },
        {
          "time": 108.469,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 108.693,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.177
        },
        {
          "time": 109.146,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 109.401,
          "lane": "right",
          "x": 0.22,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 109.688,
          "lane": "left",
          "x": 0.48,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 109.927,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 110.172,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.313
        },
        {
          "time": 110.552,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.177
        },
        {
          "time": 110.729,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 111.057,
          "lane": "right",
          "x": 0.47,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.172
        },
        {
          "time": 111.234,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.48,
          "lane": "right",
          "x": 0.54,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.727,
          "lane": "left",
          "x": 0.15,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.973,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 112.224,
          "lane": "left",
          "x": 0.22,
          "type": "iceCream",
          "pitch": 61,
          "vocalDuration": 0.229
        },
        {
          "time": 112.458,
          "lane": "right",
          "x": 0.7,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.125
        },
        {
          "time": 113.036,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.068
        },
        {
          "time": 113.781,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 113.911,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 114.161,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 114.438,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 114.672,
          "lane": "right",
          "x": 0.49,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 114.969,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 115.094,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.109
        },
        {
          "time": 115.458,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 116.458,
          "lane": "left",
          "x": 0.65,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 116.701,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 116.943,
          "lane": "left",
          "x": 0.75,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.188,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.432,
          "lane": "left",
          "x": 0.68,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.693,
          "lane": "right",
          "x": 0.26,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.276
        },
        {
          "time": 117.974,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.258
        },
        {
          "time": 118.232,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.258
        },
        {
          "time": 118.505,
          "lane": "left",
          "x": 0.5,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.417
        },
        {
          "time": 118.948,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 119.089,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 119.307,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 119.543,
          "lane": "left",
          "x": 0.35,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 119.78,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 120.021,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 120.271,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 120.526,
          "lane": "left",
          "x": 0.19,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.203
        },
        {
          "time": 121.229,
          "lane": "right",
          "x": 0.72,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.333
        },
        {
          "time": 121.568,
          "lane": "left",
          "x": 0.24,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 121.807,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 122.047,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 122.307,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 122.523,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 122.792,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.083
        },
        {
          "time": 122.875,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 123.281,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.26
        },
        {
          "time": 123.583,
          "lane": "right",
          "x": 0.39,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.193
        },
        {
          "time": 123.781,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.242
        },
        {
          "time": 124.023,
          "lane": "right",
          "x": 0.31,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.242
        },
        {
          "time": 124.292,
          "lane": "left",
          "x": 0.72,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.406
        },
        {
          "time": 124.74,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.396
        },
        {
          "time": 125.229,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 125.479,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 125.766,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.054,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.341,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.628,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.916,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 127.224,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 127.359,
          "lane": "left",
          "x": 0.36,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 127.599,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 127.839,
          "lane": "left",
          "x": 0.28,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 128.078,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 128.323,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 90,
          "vocalDuration": 0.276
        },
        {
          "time": 128.599,
          "lane": "right",
          "x": 0.72,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.276
        },
        {
          "time": 128.901,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 129.245,
          "lane": "right",
          "x": 0.77,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.083
        },
        {
          "time": 129.328,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.208
        },
        {
          "time": 129.734,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.01,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.286,
          "lane": "left",
          "x": 0.53,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.563,
          "lane": "right",
          "x": 0.6,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.839,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 131.115,
          "lane": "right",
          "x": 0.53,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 131.391,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.221
        },
        {
          "time": 131.612,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.221
        },
        {
          "time": 131.849,
          "lane": "left",
          "x": 0.75,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.071,
          "lane": "right",
          "x": 0.36,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.293,
          "lane": "left",
          "x": 0.68,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.516,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.057
        },
        {
          "time": 133.026,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 133.182,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 133.396,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 133.656,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.905,
          "lane": "left",
          "x": 0.43,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 134.153,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 134.401,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.115
        },
        {
          "time": 134.708,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.167
        },
        {
          "time": 135.031,
          "lane": "left",
          "x": 0.27,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 135.151,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.216
        },
        {
          "time": 135.367,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.216
        },
        {
          "time": 135.589,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.083
        },
        {
          "time": 135.953,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 136.234,
          "lane": "left",
          "x": 0.27,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.161
        },
        {
          "time": 136.401,
          "lane": "right",
          "x": 0.74,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.208
        },
        {
          "time": 136.964,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 137.13,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 137.427,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.234
        },
        {
          "time": 137.677,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.292
        },
        {
          "time": 138.036,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.13
        },
        {
          "time": 138.172,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.208
        },
        {
          "time": 138.479,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 138.964,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.141
        },
        {
          "time": 139.141,
          "lane": "left",
          "x": 0.69,
          "type": "donut",
          "pitch": 83,
          "vocalDuration": 0.172
        },
        {
          "time": 139.313,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.177
        },
        {
          "time": 139.495,
          "lane": "left",
          "x": 0.76,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.255
        },
        {
          "time": 139.828,
          "lane": "right",
          "x": 0.28,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.268
        },
        {
          "time": 140.096,
          "lane": "left",
          "x": 0.68,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.268
        },
        {
          "time": 140.745,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.177
        },
        {
          "time": 141.172,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.313
        },
        {
          "time": 141.484,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.182
        },
        {
          "time": 141.667,
          "lane": "left",
          "x": 0.51,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 141.807,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.305
        },
        {
          "time": 142.112,
          "lane": "left",
          "x": 0.43,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.305
        },
        {
          "time": 142.417,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.104
        },
        {
          "time": 142.656,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.198
        },
        {
          "time": 143.016,
          "lane": "right",
          "x": 0.51,
          "type": "cupcake",
          "pitch": 77,
          "vocalDuration": 0.115
        },
        {
          "time": 143.13,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 90,
          "vocalDuration": 0.161
        },
        {
          "time": 143.458,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 77,
          "vocalDuration": 0.188
        },
        {
          "time": 143.651,
          "lane": "right",
          "x": 0.59,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 143.928,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.206,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.483,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.76,
          "lane": "right",
          "x": 0.74,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.094
        },
        {
          "time": 144.922,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 145.141,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 145.37,
          "lane": "left",
          "x": 0.51,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.234
        },
        {
          "time": 145.635,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.224
        },
        {
          "time": 145.865,
          "lane": "left",
          "x": 0.56,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.12
        },
        {
          "time": 145.99,
          "lane": "right",
          "x": 0.46,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.104
        },
        {
          "time": 146.484,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 146.721,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 146.995,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.271
        },
        {
          "time": 147.266,
          "lane": "left",
          "x": 0.74,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 147.492,
          "lane": "right",
          "x": 0.27,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 147.729,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.26
        },
        {
          "time": 147.995,
          "lane": "right",
          "x": 0.16,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 148.234,
          "lane": "left",
          "x": 0.55,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 148.474,
          "lane": "right",
          "x": 0.25,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.391
        },
        {
          "time": 148.969,
          "lane": "left",
          "x": 0.52,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.151
        },
        {
          "time": 149.125,
          "lane": "right",
          "x": 0.37,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.151
        },
        {
          "time": 149.484,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.234
        },
        {
          "time": 149.766,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.094
        },
        {
          "time": 149.885,
          "lane": "right",
          "x": 0.49,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 150.164,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 150.458,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 150.69,
          "lane": "left",
          "x": 0.27,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 150.969,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.125
        },
        {
          "time": 151.125,
          "lane": "left",
          "x": 0.23,
          "type": "donut",
          "pitch": 85,
          "vocalDuration": 0.13
        },
        {
          "time": 151.542,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 151.813,
          "lane": "right",
          "x": 0.77,
          "type": "sushi",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 152.089,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.271
        },
        {
          "time": 152.359,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.271
        },
        {
          "time": 152.63,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.167
        },
        {
          "time": 152.797,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.063
        },
        {
          "time": 153.417,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.328
        },
        {
          "time": 153.745,
          "lane": "right",
          "x": 0.48,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.326
        },
        {
          "time": 154.07,
          "lane": "left",
          "x": 0.56,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.326
        },
        {
          "time": 154.401,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.089
        },
        {
          "time": 154.521,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.227
        },
        {
          "time": 154.747,
          "lane": "right",
          "x": 0.33,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.227
        },
        {
          "time": 155.031,
          "lane": "left",
          "x": 0.74,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.094
        },
        {
          "time": 155.13,
          "lane": "right",
          "x": 0.27,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.13
        },
        {
          "time": 155.505,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 155.766,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.012,
          "lane": "right",
          "x": 0.24,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.259,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.536,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.396
        },
        {
          "time": 156.958,
          "lane": "left",
          "x": 0.52,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.182
        },
        {
          "time": 157.146,
          "lane": "right",
          "x": 0.45,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.125
        },
        {
          "time": 157.781,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.109
        },
        {
          "time": 157.896,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 59,
          "vocalDuration": 0.237
        },
        {
          "time": 158.133,
          "lane": "left",
          "x": 0.29,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.237
        },
        {
          "time": 158.469,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.688,
          "lane": "left",
          "x": 0.27,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.958,
          "lane": "right",
          "x": 0.7,
          "type": "sushi",
          "pitch": 84,
          "vocalDuration": 0.318
        },
        {
          "time": 159.276,
          "lane": "left",
          "x": 0.22,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 159.545,
          "lane": "right",
          "x": 0.77,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 159.814,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 160.089,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 160.375,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 160.661,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 161.021,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.266
        },
        {
          "time": 161.286,
          "lane": "right",
          "x": 0.52,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.266
        },
        {
          "time": 161.552,
          "lane": "left",
          "x": 0.5,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 161.821,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.089,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.358,
          "lane": "right",
          "x": 0.34,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.626,
          "lane": "left",
          "x": 0.66,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.895,
          "lane": "right",
          "x": 0.26,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 163.164,
          "lane": "left",
          "x": 0.73,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 163.432,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.313
        },
        {
          "time": 163.979,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.083
        },
        {
          "time": 164.063,
          "lane": "right",
          "x": 0.26,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.344,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.625,
          "lane": "right",
          "x": 0.34,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.906,
          "lane": "left",
          "x": 0.5,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 165.224,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.302
        },
        {
          "time": 165.531,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.208
        },
        {
          "time": 165.745,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.167
        },
        {
          "time": 166.026,
          "lane": "left",
          "x": 0.33,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.182
        },
        {
          "time": 166.214,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 166.479,
          "lane": "left",
          "x": 0.26,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 166.745,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.01,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.276,
          "lane": "right",
          "x": 0.73,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.563,
          "lane": "left",
          "x": 0.27,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 167.781,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 167.995,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 168.214,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 168.512,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 168.811,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 169.214,
          "lane": "left",
          "x": 0.5,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.099
        },
        {
          "time": 169.37,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.151
        },
        {
          "time": 169.823,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.094
        },
        {
          "time": 170.026,
          "lane": "left",
          "x": 0.55,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.151
        },
        {
          "time": 170.182,
          "lane": "right",
          "x": 0.24,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.318
        },
        {
          "time": 170.505,
          "lane": "left",
          "x": 0.65,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 170.753,
          "lane": "right",
          "x": 0.18,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 171.031,
          "lane": "left",
          "x": 0.74,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.285,
          "lane": "right",
          "x": 0.27,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.538,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.839,
          "lane": "right",
          "x": 0.31,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.063,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.286,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.547,
          "lane": "left",
          "x": 0.49,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.422
        },
        {
          "time": 173.042,
          "lane": "right",
          "x": 0.52,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.094
        },
        {
          "time": 173.141,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.156
        },
        {
          "time": 173.529,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 173.958,
          "lane": "right",
          "x": 0.56,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.057
        },
        {
          "time": 174.063,
          "lane": "left",
          "x": 0.26,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 174.294,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 174.609,
          "lane": "left",
          "x": 0.19,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.391
        },
        {
          "time": 175.031,
          "lane": "right",
          "x": 0.78,
          "type": "sushi",
          "pitch": 84,
          "vocalDuration": 0.302
        },
        {
          "time": 175.344,
          "lane": "left",
          "x": 0.3,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 175.608,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 175.872,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 176.141,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.41,
          "lane": "left",
          "x": 0.46,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.679,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.953,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.248,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.543,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.875,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.052
        }
      ]
    },
    "normal": {
      "noteTravelTime": 1.9,
      "notes": [
        {
          "time": 10.823,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 38,
          "vocalDuration": 0.094
        },
        {
          "time": 16.276,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 62,
          "vocalDuration": 0.068
        },
        {
          "time": 16.438,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.198
        },
        {
          "time": 16.635,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 62,
          "vocalDuration": 0.141
        },
        {
          "time": 16.776,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.219
        },
        {
          "time": 16.995,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.219
        },
        {
          "time": 17.214,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 61,
          "vocalDuration": 0.266
        },
        {
          "time": 17.479,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 60,
          "vocalDuration": 0.146
        },
        {
          "time": 17.63,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 61,
          "vocalDuration": 0.172
        },
        {
          "time": 17.802,
          "lane": "right",
          "x": 0.27,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.286
        },
        {
          "time": 18.089,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.286
        },
        {
          "time": 18.375,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.167
        },
        {
          "time": 18.583,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.115
        },
        {
          "time": 18.781,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.401
        },
        {
          "time": 19.214,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.38
        },
        {
          "time": 19.62,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 59,
          "vocalDuration": 0.333
        },
        {
          "time": 19.964,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.237
        },
        {
          "time": 20.201,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.237
        },
        {
          "time": 20.682,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 20.905,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 21.127,
          "lane": "left",
          "x": 0.28,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 21.641,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 21.908,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.174,
          "lane": "right",
          "x": 0.49,
          "type": "sushi",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.441,
          "lane": "left",
          "x": 0.49,
          "type": "iceCream",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.714,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 58,
          "vocalDuration": 0.172
        },
        {
          "time": 22.891,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.242
        },
        {
          "time": 23.133,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.242
        },
        {
          "time": 23.375,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.396
        },
        {
          "time": 23.776,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 24.008,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 24.406,
          "lane": "right",
          "x": 0.25,
          "type": "fish",
          "pitch": 59,
          "vocalDuration": 0.208
        },
        {
          "time": 24.62,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.318
        },
        {
          "time": 24.938,
          "lane": "right",
          "x": 0.39,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.318
        },
        {
          "time": 25.26,
          "lane": "left",
          "x": 0.26,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.203
        },
        {
          "time": 25.469,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 60,
          "vocalDuration": 0.146
        },
        {
          "time": 25.62,
          "lane": "left",
          "x": 0.14,
          "type": "iceCream",
          "pitch": 62,
          "vocalDuration": 0.177
        },
        {
          "time": 25.797,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 26.052,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 26.313,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 61,
          "vocalDuration": 0.375
        },
        {
          "time": 26.766,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.198
        },
        {
          "time": 27.411,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.068
        },
        {
          "time": 27.635,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.339
        },
        {
          "time": 27.974,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 61,
          "vocalDuration": 0.365
        },
        {
          "time": 28.474,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 61,
          "vocalDuration": 0.109
        },
        {
          "time": 28.792,
          "lane": "right",
          "x": 0.29,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 29.057,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 29.323,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 29.594,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.234
        },
        {
          "time": 29.828,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.208
        },
        {
          "time": 30.036,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 30.26,
          "lane": "right",
          "x": 0.41,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 30.49,
          "lane": "left",
          "x": 0.3,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.141
        },
        {
          "time": 30.813,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.063,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.313,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.766,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.234
        },
        {
          "time": 32.266,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 32.76,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 32.987,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 33.281,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 33.51,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 33.755,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.323
        },
        {
          "time": 34.25,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 34.5,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 34.766,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 35.031,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 35.474,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.359
        },
        {
          "time": 36.016,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.272,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.529,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.785,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 37.047,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.078
        },
        {
          "time": 37.13,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.414,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.698,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.982,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 38.276,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.411
        },
        {
          "time": 38.698,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.271
        },
        {
          "time": 39.281,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.219
        },
        {
          "time": 39.5,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.219
        },
        {
          "time": 39.745,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.219
        },
        {
          "time": 39.974,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.104
        },
        {
          "time": 40.24,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.234
        },
        {
          "time": 40.552,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.167
        },
        {
          "time": 40.766,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.247
        },
        {
          "time": 41.013,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.247
        },
        {
          "time": 41.292,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.232
        },
        {
          "time": 41.523,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.232
        },
        {
          "time": 41.776,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.214
        },
        {
          "time": 42.276,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.286
        },
        {
          "time": 42.755,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.276
        },
        {
          "time": 43.042,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.208
        },
        {
          "time": 43.281,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.115
        },
        {
          "time": 43.521,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.37
        },
        {
          "time": 43.974,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.328,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 44.693,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 44.964,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 45.286,
          "lane": "right",
          "x": 0.29,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.057
        },
        {
          "time": 45.344,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.307
        },
        {
          "time": 45.656,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 45.948,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.094
        },
        {
          "time": 46.047,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.141
        },
        {
          "time": 46.193,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 46.469,
          "lane": "right",
          "x": 0.41,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 46.745,
          "lane": "left",
          "x": 0.29,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.021,
          "lane": "right",
          "x": 0.53,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.297,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.573,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.943,
          "lane": "left",
          "x": 0.29,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 48.214,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 48.49,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.245
        },
        {
          "time": 48.734,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.245
        },
        {
          "time": 49.01,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.26,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.51,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.813,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.036,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.26,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.49,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.135
        },
        {
          "time": 50.63,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.286
        },
        {
          "time": 50.964,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.125
        },
        {
          "time": 51.094,
          "lane": "right",
          "x": 0.46,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.161
        },
        {
          "time": 51.26,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 51.492,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 51.75,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 51.988,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 52.226,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 52.484,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 52.727,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 52.995,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 53.141,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.193
        },
        {
          "time": 53.333,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 53.58,
          "lane": "left",
          "x": 0.69,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 53.826,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 54.073,
          "lane": "left",
          "x": 0.68,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 54.378,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 54.684,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 55.5,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.219
        },
        {
          "time": 55.724,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 55.976,
          "lane": "right",
          "x": 0.41,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 56.227,
          "lane": "left",
          "x": 0.29,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 56.49,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 56.721,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 56.984,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.12
        },
        {
          "time": 57.109,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 57.245,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.255
        },
        {
          "time": 57.5,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.255
        },
        {
          "time": 57.771,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.01,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.25,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.51,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.411
        },
        {
          "time": 58.943,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.161
        },
        {
          "time": 59.104,
          "lane": "left",
          "x": 0.7,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.151
        },
        {
          "time": 59.255,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.242
        },
        {
          "time": 59.497,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.242
        },
        {
          "time": 59.766,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.009,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.252,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.531,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.216
        },
        {
          "time": 60.747,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.216
        },
        {
          "time": 61.005,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.219
        },
        {
          "time": 61.224,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 61.497,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 61.769,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.042,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.314,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.587,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.953,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.151
        },
        {
          "time": 63.125,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.263
        },
        {
          "time": 63.388,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.263
        },
        {
          "time": 63.672,
          "lane": "left",
          "x": 0.69,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.151
        },
        {
          "time": 63.839,
          "lane": "right",
          "x": 0.21,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.354
        },
        {
          "time": 64.464,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.25
        },
        {
          "time": 64.823,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.12
        },
        {
          "time": 64.964,
          "lane": "left",
          "x": 0.46,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.359
        },
        {
          "time": 65.323,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 65.549,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 65.802,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.281
        },
        {
          "time": 66.083,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.281
        },
        {
          "time": 67.016,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.115
        },
        {
          "time": 67.141,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 67.391,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 67.646,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 67.896,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 68.146,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 68.401,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.104
        },
        {
          "time": 68.953,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.188
        },
        {
          "time": 69.146,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.253
        },
        {
          "time": 69.398,
          "lane": "left",
          "x": 0.69,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.253
        },
        {
          "time": 69.651,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.297
        },
        {
          "time": 69.948,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.068
        },
        {
          "time": 70.396,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.135
        },
        {
          "time": 70.542,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.052
        },
        {
          "time": 70.974,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.182
        },
        {
          "time": 71.161,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 71.438,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 71.698,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.286
        },
        {
          "time": 72.042,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.109
        },
        {
          "time": 72.151,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.234
        },
        {
          "time": 72.448,
          "lane": "right",
          "x": 0.7,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.229
        },
        {
          "time": 72.677,
          "lane": "left",
          "x": 0.46,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.229
        },
        {
          "time": 72.974,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.12
        },
        {
          "time": 73.104,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.193
        },
        {
          "time": 73.302,
          "lane": "right",
          "x": 0.46,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.188
        },
        {
          "time": 73.547,
          "lane": "left",
          "x": 0.7,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.25
        },
        {
          "time": 73.813,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.331
        },
        {
          "time": 74.143,
          "lane": "left",
          "x": 0.69,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.331
        },
        {
          "time": 74.661,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 77,
          "vocalDuration": 0.104
        },
        {
          "time": 74.771,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.188
        },
        {
          "time": 75.161,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 75.406,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 75.656,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.318
        },
        {
          "time": 75.979,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.411
        },
        {
          "time": 76.396,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 76.594,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.313
        },
        {
          "time": 76.995,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.13
        },
        {
          "time": 77.125,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 77.281,
          "lane": "right",
          "x": 0.74,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.167
        },
        {
          "time": 77.453,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 77,
          "vocalDuration": 0.167
        },
        {
          "time": 77.625,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 77.866,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 78.108,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 78.354,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.146
        },
        {
          "time": 78.516,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.375
        },
        {
          "time": 78.906,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.229
        },
        {
          "time": 79.141,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.214
        },
        {
          "time": 79.359,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.224
        },
        {
          "time": 79.599,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 79.854,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 79.979,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.12
        },
        {
          "time": 80.099,
          "lane": "left",
          "x": 0.29,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.344
        },
        {
          "time": 80.474,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 80.708,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 80.964,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 81.255,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 81.482,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 81.75,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.224
        },
        {
          "time": 81.979,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 82.214,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 82.474,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.237
        },
        {
          "time": 82.711,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.237
        },
        {
          "time": 82.974,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.141
        },
        {
          "time": 83.12,
          "lane": "left",
          "x": 0.7,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.156
        },
        {
          "time": 83.281,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.221
        },
        {
          "time": 83.503,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.221
        },
        {
          "time": 83.766,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.083
        },
        {
          "time": 83.88,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 84.159,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 84.484,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.216
        },
        {
          "time": 84.701,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.216
        },
        {
          "time": 84.964,
          "lane": "left",
          "x": 0.22,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.146
        },
        {
          "time": 85.115,
          "lane": "right",
          "x": 0.72,
          "type": "fish",
          "pitch": 85,
          "vocalDuration": 0.146
        },
        {
          "time": 85.26,
          "lane": "left",
          "x": 0.34,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 85.528,
          "lane": "right",
          "x": 0.71,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 85.795,
          "lane": "left",
          "x": 0.46,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 86.068,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.219
        },
        {
          "time": 86.286,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.245
        },
        {
          "time": 86.531,
          "lane": "right",
          "x": 0.46,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.245
        },
        {
          "time": 86.781,
          "lane": "left",
          "x": 0.71,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.094
        },
        {
          "time": 86.875,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.255
        },
        {
          "time": 87.76,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.31
        },
        {
          "time": 88.07,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.31
        },
        {
          "time": 88.385,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.099
        },
        {
          "time": 88.484,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 88.716,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 89,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.125
        },
        {
          "time": 89.125,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.099
        },
        {
          "time": 89.229,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.237
        },
        {
          "time": 89.466,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.237
        },
        {
          "time": 89.75,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 89.991,
          "lane": "left",
          "x": 0.28,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 90.233,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 90.536,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.38
        },
        {
          "time": 90.953,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 91.109,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.125
        },
        {
          "time": 91.24,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 91.49,
          "lane": "left",
          "x": 0.69,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 91.786,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 72,
          "vocalDuration": 0.104
        },
        {
          "time": 91.896,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 92.161,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 92.479,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.422
        },
        {
          "time": 92.953,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.109
        },
        {
          "time": 93.078,
          "lane": "left",
          "x": 0.48,
          "type": "donut",
          "pitch": 85,
          "vocalDuration": 0.198
        },
        {
          "time": 93.276,
          "lane": "right",
          "x": 0.46,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.115
        },
        {
          "time": 93.469,
          "lane": "left",
          "x": 0.34,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.292
        },
        {
          "time": 93.76,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 82,
          "vocalDuration": 0.292
        },
        {
          "time": 94.057,
          "lane": "left",
          "x": 0.22,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.342,
          "lane": "right",
          "x": 0.71,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.627,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.911,
          "lane": "right",
          "x": 0.71,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.094
        },
        {
          "time": 95.292,
          "lane": "left",
          "x": 0.47,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.083
        },
        {
          "time": 97.375,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 59,
          "vocalDuration": 0.323
        },
        {
          "time": 97.698,
          "lane": "left",
          "x": 0.5,
          "type": "iceCream",
          "pitch": 59,
          "vocalDuration": 0.323
        },
        {
          "time": 98.094,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.203
        },
        {
          "time": 98.302,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.193
        },
        {
          "time": 98.552,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 98.786,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 99.021,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 99.286,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.068
        },
        {
          "time": 99.354,
          "lane": "right",
          "x": 0.29,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.151
        },
        {
          "time": 99.51,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 99.724,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 100.078,
          "lane": "left",
          "x": 0.29,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.182
        },
        {
          "time": 100.26,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 100.51,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 100.76,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 101.01,
          "lane": "left",
          "x": 0.29,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.115
        },
        {
          "time": 101.13,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.146
        },
        {
          "time": 101.609,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.302
        },
        {
          "time": 101.911,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.302
        },
        {
          "time": 102.219,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.151
        },
        {
          "time": 102.375,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 102.641,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 102.938,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.05
        },
        {
          "time": 102.99,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.276
        },
        {
          "time": 103.266,
          "lane": "right",
          "x": 0.15,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 103.563,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 103.859,
          "lane": "right",
          "x": 0.27,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 104.156,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 104.458,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 61,
          "vocalDuration": 0.224
        },
        {
          "time": 105.406,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 59,
          "vocalDuration": 0.281
        },
        {
          "time": 105.688,
          "lane": "right",
          "x": 0.5,
          "type": "sushi",
          "pitch": 59,
          "vocalDuration": 0.281
        },
        {
          "time": 106,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 106.234,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.161
        },
        {
          "time": 106.469,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 106.734,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 107,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.245,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.49,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.802,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.146
        },
        {
          "time": 107.948,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.232
        },
        {
          "time": 108.18,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.232
        },
        {
          "time": 108.469,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 108.693,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.177
        },
        {
          "time": 109.146,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 109.401,
          "lane": "right",
          "x": 0.27,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 109.688,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 109.927,
          "lane": "right",
          "x": 0.41,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 110.172,
          "lane": "left",
          "x": 0.28,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.313
        },
        {
          "time": 110.552,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.177
        },
        {
          "time": 110.729,
          "lane": "left",
          "x": 0.15,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 111.057,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.172
        },
        {
          "time": 111.234,
          "lane": "left",
          "x": 0.27,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.48,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.727,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.973,
          "lane": "right",
          "x": 0.51,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 112.224,
          "lane": "left",
          "x": 0.51,
          "type": "iceCream",
          "pitch": 61,
          "vocalDuration": 0.229
        },
        {
          "time": 112.458,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.125
        },
        {
          "time": 113.036,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.068
        },
        {
          "time": 113.781,
          "lane": "right",
          "x": 0.29,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 113.911,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 114.161,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 114.438,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 114.672,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 114.969,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 115.094,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.109
        },
        {
          "time": 115.208,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 115.458,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 116.458,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 116.701,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 116.943,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.188,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.432,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.693,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.276
        },
        {
          "time": 117.974,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.258
        },
        {
          "time": 118.232,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.258
        },
        {
          "time": 118.505,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.417
        },
        {
          "time": 118.948,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 119.089,
          "lane": "left",
          "x": 0.69,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 119.307,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 119.543,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 119.78,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 120.021,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 120.271,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 120.526,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.203
        },
        {
          "time": 121.229,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.333
        },
        {
          "time": 121.568,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 121.807,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 122.047,
          "lane": "left",
          "x": 0.29,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 122.307,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 122.523,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 122.792,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.083
        },
        {
          "time": 122.875,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 123.021,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.26
        },
        {
          "time": 123.281,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.26
        },
        {
          "time": 123.583,
          "lane": "right",
          "x": 0.28,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.193
        },
        {
          "time": 123.781,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.242
        },
        {
          "time": 124.023,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.242
        },
        {
          "time": 124.292,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.406
        },
        {
          "time": 124.74,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.396
        },
        {
          "time": 125.229,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 125.479,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 125.766,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.054,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.341,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.628,
          "lane": "right",
          "x": 0.68,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.916,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 127.224,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 127.359,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 127.599,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 127.839,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 128.078,
          "lane": "right",
          "x": 0.45,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 128.323,
          "lane": "left",
          "x": 0.74,
          "type": "donut",
          "pitch": 90,
          "vocalDuration": 0.276
        },
        {
          "time": 128.599,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.276
        },
        {
          "time": 128.901,
          "lane": "left",
          "x": 0.71,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 129.245,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.083
        },
        {
          "time": 129.328,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.208
        },
        {
          "time": 129.542,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.141
        },
        {
          "time": 129.734,
          "lane": "left",
          "x": 0.46,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.01,
          "lane": "right",
          "x": 0.46,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.286,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.563,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.839,
          "lane": "left",
          "x": 0.21,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 131.115,
          "lane": "right",
          "x": 0.7,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 131.391,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.221
        },
        {
          "time": 131.612,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.221
        },
        {
          "time": 131.849,
          "lane": "left",
          "x": 0.45,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.071,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.293,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.516,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.057
        },
        {
          "time": 133.026,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 133.182,
          "lane": "right",
          "x": 0.33,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 133.396,
          "lane": "left",
          "x": 0.69,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 133.656,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.905,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 134.153,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 134.401,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.115
        },
        {
          "time": 134.708,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.167
        },
        {
          "time": 135.031,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 135.151,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.216
        },
        {
          "time": 135.367,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.216
        },
        {
          "time": 135.589,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.083
        },
        {
          "time": 135.677,
          "lane": "left",
          "x": 0.32,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 135.953,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 136.234,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.161
        },
        {
          "time": 136.401,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.208
        },
        {
          "time": 136.964,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 137.13,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 137.427,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.234
        },
        {
          "time": 137.677,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.292
        },
        {
          "time": 138.036,
          "lane": "left",
          "x": 0.69,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.13
        },
        {
          "time": 138.172,
          "lane": "right",
          "x": 0.21,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.208
        },
        {
          "time": 138.479,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 138.964,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.141
        },
        {
          "time": 139.141,
          "lane": "left",
          "x": 0.47,
          "type": "donut",
          "pitch": 83,
          "vocalDuration": 0.172
        },
        {
          "time": 139.313,
          "lane": "right",
          "x": 0.46,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.177
        },
        {
          "time": 139.495,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.255
        },
        {
          "time": 139.828,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.268
        },
        {
          "time": 140.096,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.268
        },
        {
          "time": 140.745,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.177
        },
        {
          "time": 141.172,
          "lane": "left",
          "x": 0.33,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.313
        },
        {
          "time": 141.484,
          "lane": "right",
          "x": 0.74,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.182
        },
        {
          "time": 141.667,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 141.807,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.305
        },
        {
          "time": 142.112,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.305
        },
        {
          "time": 142.417,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.104
        },
        {
          "time": 142.656,
          "lane": "left",
          "x": 0.69,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.198
        },
        {
          "time": 143.016,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 77,
          "vocalDuration": 0.115
        },
        {
          "time": 143.13,
          "lane": "left",
          "x": 0.74,
          "type": "candy",
          "pitch": 90,
          "vocalDuration": 0.161
        },
        {
          "time": 143.292,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.167
        },
        {
          "time": 143.458,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 77,
          "vocalDuration": 0.188
        },
        {
          "time": 143.651,
          "lane": "right",
          "x": 0.32,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 143.928,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.206,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.483,
          "lane": "left",
          "x": 0.32,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.76,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.094
        },
        {
          "time": 144.922,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 145.141,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 145.37,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.234
        },
        {
          "time": 145.635,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.224
        },
        {
          "time": 145.865,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.12
        },
        {
          "time": 145.99,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.104
        },
        {
          "time": 146.099,
          "lane": "left",
          "x": 0.53,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.359
        },
        {
          "time": 146.484,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 146.721,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 146.995,
          "lane": "right",
          "x": 0.32,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.271
        },
        {
          "time": 147.266,
          "lane": "left",
          "x": 0.68,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 147.492,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 147.729,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.26
        },
        {
          "time": 147.995,
          "lane": "right",
          "x": 0.28,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 148.234,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 148.474,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.391
        },
        {
          "time": 148.969,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.151
        },
        {
          "time": 149.125,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.151
        },
        {
          "time": 149.281,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.13
        },
        {
          "time": 149.484,
          "lane": "right",
          "x": 0.69,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.234
        },
        {
          "time": 149.766,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.094
        },
        {
          "time": 149.885,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 150.164,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 150.458,
          "lane": "right",
          "x": 0.56,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 150.69,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 150.969,
          "lane": "right",
          "x": 0.46,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.125
        },
        {
          "time": 151.125,
          "lane": "left",
          "x": 0.72,
          "type": "donut",
          "pitch": 85,
          "vocalDuration": 0.13
        },
        {
          "time": 151.271,
          "lane": "right",
          "x": 0.34,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 151.542,
          "lane": "left",
          "x": 0.71,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 151.813,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 152.089,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.271
        },
        {
          "time": 152.359,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.271
        },
        {
          "time": 152.63,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.167
        },
        {
          "time": 152.797,
          "lane": "right",
          "x": 0.47,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.063
        },
        {
          "time": 152.896,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.161
        },
        {
          "time": 153.057,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.323
        },
        {
          "time": 153.417,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.328
        },
        {
          "time": 153.745,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.326
        },
        {
          "time": 154.07,
          "lane": "left",
          "x": 0.29,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.326
        },
        {
          "time": 154.401,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.089
        },
        {
          "time": 154.521,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.227
        },
        {
          "time": 154.747,
          "lane": "right",
          "x": 0.54,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.227
        },
        {
          "time": 155.031,
          "lane": "left",
          "x": 0.56,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.094
        },
        {
          "time": 155.13,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.13
        },
        {
          "time": 155.266,
          "lane": "left",
          "x": 0.68,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 155.505,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 155.766,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.012,
          "lane": "right",
          "x": 0.16,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.259,
          "lane": "left",
          "x": 0.52,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.536,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.396
        },
        {
          "time": 156.958,
          "lane": "left",
          "x": 0.45,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.182
        },
        {
          "time": 157.146,
          "lane": "right",
          "x": 0.46,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.125
        },
        {
          "time": 157.276,
          "lane": "left",
          "x": 0.33,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.094
        },
        {
          "time": 157.458,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.286
        },
        {
          "time": 157.781,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.109
        },
        {
          "time": 157.896,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 59,
          "vocalDuration": 0.237
        },
        {
          "time": 158.133,
          "lane": "left",
          "x": 0.25,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.237
        },
        {
          "time": 158.469,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.688,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.958,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 84,
          "vocalDuration": 0.318
        },
        {
          "time": 159.276,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 159.545,
          "lane": "right",
          "x": 0.46,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 159.814,
          "lane": "left",
          "x": 0.71,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 160.089,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 160.375,
          "lane": "left",
          "x": 0.71,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 160.661,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 161.021,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.266
        },
        {
          "time": 161.286,
          "lane": "right",
          "x": 0.33,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.266
        },
        {
          "time": 161.552,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 161.821,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.089,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.358,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.626,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.895,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 163.164,
          "lane": "left",
          "x": 0.31,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 163.432,
          "lane": "right",
          "x": 0.68,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.313
        },
        {
          "time": 163.979,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.083
        },
        {
          "time": 164.063,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.344,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.625,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.906,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 165.224,
          "lane": "right",
          "x": 0.31,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.302
        },
        {
          "time": 165.531,
          "lane": "left",
          "x": 0.67,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.208
        },
        {
          "time": 165.745,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.167
        },
        {
          "time": 166.026,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.182
        },
        {
          "time": 166.214,
          "lane": "right",
          "x": 0.31,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 166.479,
          "lane": "left",
          "x": 0.43,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 166.745,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.01,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.276,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.563,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 167.781,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 167.995,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 168.214,
          "lane": "right",
          "x": 0.67,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 168.512,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 168.811,
          "lane": "right",
          "x": 0.55,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 169.214,
          "lane": "left",
          "x": 0.55,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.099
        },
        {
          "time": 169.37,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.151
        },
        {
          "time": 169.521,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 169.823,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.094
        },
        {
          "time": 170.026,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.151
        },
        {
          "time": 170.182,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.318
        },
        {
          "time": 170.505,
          "lane": "left",
          "x": 0.54,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 170.753,
          "lane": "right",
          "x": 0.3,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 171.031,
          "lane": "left",
          "x": 0.44,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.285,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.538,
          "lane": "left",
          "x": 0.31,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.839,
          "lane": "right",
          "x": 0.52,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.063,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.286,
          "lane": "right",
          "x": 0.65,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.547,
          "lane": "left",
          "x": 0.3,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.422
        },
        {
          "time": 173.042,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.094
        },
        {
          "time": 173.141,
          "lane": "left",
          "x": 0.46,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.156
        },
        {
          "time": 173.297,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 173.529,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 173.958,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.057
        },
        {
          "time": 174.063,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 174.294,
          "lane": "right",
          "x": 0.3,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 174.609,
          "lane": "left",
          "x": 0.68,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.391
        },
        {
          "time": 175.031,
          "lane": "right",
          "x": 0.23,
          "type": "sushi",
          "pitch": 84,
          "vocalDuration": 0.302
        },
        {
          "time": 175.344,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 175.608,
          "lane": "right",
          "x": 0.34,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 175.872,
          "lane": "left",
          "x": 0.46,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 176.141,
          "lane": "right",
          "x": 0.47,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.41,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.679,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.953,
          "lane": "left",
          "x": 0.22,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.248,
          "lane": "right",
          "x": 0.71,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.543,
          "lane": "left",
          "x": 0.34,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.875,
          "lane": "right",
          "x": 0.71,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.052
        }
      ]
    },
    "hard": {
      "noteTravelTime": 1.9,
      "notes": [
        {
          "time": 10.823,
          "lane": "left",
          "x": 0.08,
          "type": "iceCream",
          "pitch": 38,
          "vocalDuration": 0.094
        },
        {
          "time": 16.276,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 62,
          "vocalDuration": 0.068
        },
        {
          "time": 16.438,
          "lane": "left",
          "x": 0.35,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.198
        },
        {
          "time": 16.635,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 62,
          "vocalDuration": 0.141
        },
        {
          "time": 16.776,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.219
        },
        {
          "time": 16.995,
          "lane": "right",
          "x": 0.37,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.219
        },
        {
          "time": 17.214,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 61,
          "vocalDuration": 0.266
        },
        {
          "time": 17.479,
          "lane": "right",
          "x": 0.13,
          "type": "fish",
          "pitch": 60,
          "vocalDuration": 0.146
        },
        {
          "time": 17.63,
          "lane": "left",
          "x": 0.36,
          "type": "donut",
          "pitch": 61,
          "vocalDuration": 0.172
        },
        {
          "time": 17.802,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.286
        },
        {
          "time": 18.089,
          "lane": "left",
          "x": 0.15,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.286
        },
        {
          "time": 18.375,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.167
        },
        {
          "time": 18.583,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.115
        },
        {
          "time": 18.781,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.401
        },
        {
          "time": 19.214,
          "lane": "left",
          "x": 0.6,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.38
        },
        {
          "time": 19.62,
          "lane": "right",
          "x": 0.35,
          "type": "cupcake",
          "pitch": 59,
          "vocalDuration": 0.333
        },
        {
          "time": 19.964,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.237
        },
        {
          "time": 20.201,
          "lane": "right",
          "x": 0.14,
          "type": "sushi",
          "pitch": 61,
          "vocalDuration": 0.237
        },
        {
          "time": 20.682,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 20.905,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 21.127,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.222
        },
        {
          "time": 21.641,
          "lane": "right",
          "x": 0.57,
          "type": "cupcake",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 21.908,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.174,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.441,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 58,
          "vocalDuration": 0.267
        },
        {
          "time": 22.714,
          "lane": "right",
          "x": 0.35,
          "type": "fish",
          "pitch": 58,
          "vocalDuration": 0.172
        },
        {
          "time": 22.891,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.242
        },
        {
          "time": 23.133,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.242
        },
        {
          "time": 23.375,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.396
        },
        {
          "time": 23.776,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 24.008,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 24.406,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 59,
          "vocalDuration": 0.208
        },
        {
          "time": 24.62,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.318
        },
        {
          "time": 24.938,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.318
        },
        {
          "time": 25.26,
          "lane": "left",
          "x": 0.58,
          "type": "candy",
          "pitch": 61,
          "vocalDuration": 0.203
        },
        {
          "time": 25.469,
          "lane": "right",
          "x": 0.35,
          "type": "sushi",
          "pitch": 60,
          "vocalDuration": 0.146
        },
        {
          "time": 25.62,
          "lane": "left",
          "x": 0.58,
          "type": "iceCream",
          "pitch": 62,
          "vocalDuration": 0.177
        },
        {
          "time": 25.797,
          "lane": "right",
          "x": 0.15,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 26.052,
          "lane": "left",
          "x": 0.37,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 26.313,
          "lane": "right",
          "x": 0.36,
          "type": "cupcake",
          "pitch": 61,
          "vocalDuration": 0.375
        },
        {
          "time": 26.766,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.198
        },
        {
          "time": 27.411,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.068
        },
        {
          "time": 27.635,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.339
        },
        {
          "time": 27.974,
          "lane": "right",
          "x": 0.58,
          "type": "fish",
          "pitch": 61,
          "vocalDuration": 0.365
        },
        {
          "time": 28.474,
          "lane": "left",
          "x": 0.58,
          "type": "donut",
          "pitch": 61,
          "vocalDuration": 0.109
        },
        {
          "time": 28.792,
          "lane": "right",
          "x": 0.39,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 29.057,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 29.323,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 29.594,
          "lane": "left",
          "x": 0.39,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.234
        },
        {
          "time": 29.828,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.208
        },
        {
          "time": 30.036,
          "lane": "left",
          "x": 0.17,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 30.26,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 30.49,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.141
        },
        {
          "time": 30.813,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.063,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.313,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 31.766,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.234
        },
        {
          "time": 32.266,
          "lane": "right",
          "x": 0.18,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 32.76,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 32.987,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.227
        },
        {
          "time": 33.281,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 33.51,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.229
        },
        {
          "time": 33.755,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.323
        },
        {
          "time": 34.25,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 34.5,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 34.766,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 35.031,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 35.474,
          "lane": "right",
          "x": 0.18,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.359
        },
        {
          "time": 36.016,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.272,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.529,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 36.785,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.257
        },
        {
          "time": 37.047,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.078
        },
        {
          "time": 37.13,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.414,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.698,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 37.982,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.284
        },
        {
          "time": 38.276,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.411
        },
        {
          "time": 38.698,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.271
        },
        {
          "time": 39.281,
          "lane": "right",
          "x": 0.38,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.219
        },
        {
          "time": 39.5,
          "lane": "left",
          "x": 0.16,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.219
        },
        {
          "time": 39.745,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.219
        },
        {
          "time": 39.974,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.104
        },
        {
          "time": 40.24,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.234
        },
        {
          "time": 40.552,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.167
        },
        {
          "time": 40.766,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.247
        },
        {
          "time": 41.013,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.247
        },
        {
          "time": 41.292,
          "lane": "right",
          "x": 0.16,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.232
        },
        {
          "time": 41.523,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.232
        },
        {
          "time": 41.776,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.214
        },
        {
          "time": 42.276,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.286
        },
        {
          "time": 42.755,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.276
        },
        {
          "time": 43.042,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.208
        },
        {
          "time": 43.281,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.115
        },
        {
          "time": 43.521,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.37
        },
        {
          "time": 43.974,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.24
        },
        {
          "time": 44.328,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 44.693,
          "lane": "right",
          "x": 0.18,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 44.964,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 45.286,
          "lane": "right",
          "x": 0.39,
          "type": "cupcake",
          "pitch": 69,
          "vocalDuration": 0.057
        },
        {
          "time": 45.344,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.307
        },
        {
          "time": 45.656,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.266
        },
        {
          "time": 45.948,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.094
        },
        {
          "time": 46.047,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.141
        },
        {
          "time": 46.193,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 46.469,
          "lane": "right",
          "x": 0.39,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 46.745,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.021,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.297,
          "lane": "left",
          "x": 0.39,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.573,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.276
        },
        {
          "time": 47.943,
          "lane": "left",
          "x": 0.17,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 48.214,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.271
        },
        {
          "time": 48.49,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.245
        },
        {
          "time": 48.734,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.245
        },
        {
          "time": 49.01,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.26,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.51,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 49.813,
          "lane": "right",
          "x": 0.16,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.036,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.26,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 50.49,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.135
        },
        {
          "time": 50.63,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.286
        },
        {
          "time": 50.964,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.125
        },
        {
          "time": 51.094,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.161
        },
        {
          "time": 51.26,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 51.492,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 51.75,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 51.988,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 52.226,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.238
        },
        {
          "time": 52.484,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 52.727,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.242
        },
        {
          "time": 52.995,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 53.141,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.193
        },
        {
          "time": 53.333,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 53.58,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 53.826,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.247
        },
        {
          "time": 54.073,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 54.378,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 54.684,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.306
        },
        {
          "time": 55.5,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.219
        },
        {
          "time": 55.724,
          "lane": "left",
          "x": 0.17,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 55.976,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 56.227,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.252
        },
        {
          "time": 56.49,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 56.721,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 56.984,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 74,
          "vocalDuration": 0.12
        },
        {
          "time": 57.109,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 57.245,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.255
        },
        {
          "time": 57.5,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.255
        },
        {
          "time": 57.771,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.01,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.25,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 58.51,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.411
        },
        {
          "time": 58.943,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.161
        },
        {
          "time": 59.104,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.151
        },
        {
          "time": 59.255,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.242
        },
        {
          "time": 59.497,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.242
        },
        {
          "time": 59.766,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.009,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.252,
          "lane": "right",
          "x": 0.39,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.243
        },
        {
          "time": 60.531,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.216
        },
        {
          "time": 60.747,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.216
        },
        {
          "time": 61.005,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.219
        },
        {
          "time": 61.224,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 61.497,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 61.769,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.042,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.314,
          "lane": "right",
          "x": 0.2,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.587,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.273
        },
        {
          "time": 62.953,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 72,
          "vocalDuration": 0.151
        },
        {
          "time": 63.125,
          "lane": "left",
          "x": 0.19,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.263
        },
        {
          "time": 63.388,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.263
        },
        {
          "time": 63.672,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.151
        },
        {
          "time": 63.839,
          "lane": "right",
          "x": 0.65,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.354
        },
        {
          "time": 64.464,
          "lane": "left",
          "x": 0.65,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.25
        },
        {
          "time": 64.823,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.12
        },
        {
          "time": 64.964,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.359
        },
        {
          "time": 65.323,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 65.549,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 65.802,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.281
        },
        {
          "time": 66.083,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.281
        },
        {
          "time": 67.016,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.115
        },
        {
          "time": 67.141,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 67.391,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 67.646,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 67.896,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 68.146,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.25
        },
        {
          "time": 68.401,
          "lane": "right",
          "x": 0.19,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.104
        },
        {
          "time": 68.953,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.188
        },
        {
          "time": 69.146,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.253
        },
        {
          "time": 69.398,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.253
        },
        {
          "time": 69.651,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.297
        },
        {
          "time": 69.948,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.068
        },
        {
          "time": 70.396,
          "lane": "right",
          "x": 0.63,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.135
        },
        {
          "time": 70.542,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.052
        },
        {
          "time": 70.974,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.182
        },
        {
          "time": 71.161,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.25
        },
        {
          "time": 71.438,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 71.698,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.286
        },
        {
          "time": 72.042,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.109
        },
        {
          "time": 72.151,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.234
        },
        {
          "time": 72.448,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.229
        },
        {
          "time": 72.677,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.229
        },
        {
          "time": 72.974,
          "lane": "right",
          "x": 0.65,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.12
        },
        {
          "time": 73.104,
          "lane": "left",
          "x": 0.66,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.193
        },
        {
          "time": 73.302,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.188
        },
        {
          "time": 73.547,
          "lane": "left",
          "x": 0.65,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.25
        },
        {
          "time": 73.813,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.331
        },
        {
          "time": 74.143,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.331
        },
        {
          "time": 74.661,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 77,
          "vocalDuration": 0.104
        },
        {
          "time": 74.771,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.188
        },
        {
          "time": 75.161,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 75.406,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 75.656,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.318
        },
        {
          "time": 75.979,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.411
        },
        {
          "time": 76.396,
          "lane": "right",
          "x": 0.41,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 76.594,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.313
        },
        {
          "time": 76.995,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.13
        },
        {
          "time": 77.125,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 77.281,
          "lane": "right",
          "x": 0.47,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.167
        },
        {
          "time": 77.453,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 77,
          "vocalDuration": 0.167
        },
        {
          "time": 77.625,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 77.866,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 78.108,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.241
        },
        {
          "time": 78.354,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.146
        },
        {
          "time": 78.516,
          "lane": "right",
          "x": 0.41,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.375
        },
        {
          "time": 78.906,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.229
        },
        {
          "time": 79.141,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.214
        },
        {
          "time": 79.359,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.224
        },
        {
          "time": 79.599,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.24
        },
        {
          "time": 79.854,
          "lane": "left",
          "x": 0.17,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 79.979,
          "lane": "right",
          "x": 0.59,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.12
        },
        {
          "time": 80.099,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.344
        },
        {
          "time": 80.474,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 80.708,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 80.964,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.286
        },
        {
          "time": 81.255,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 81.482,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 81.75,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.224
        },
        {
          "time": 81.979,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 82.214,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.234
        },
        {
          "time": 82.474,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.237
        },
        {
          "time": 82.711,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.237
        },
        {
          "time": 82.974,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.141
        },
        {
          "time": 83.12,
          "lane": "left",
          "x": 0.65,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.156
        },
        {
          "time": 83.281,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.221
        },
        {
          "time": 83.503,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.221
        },
        {
          "time": 83.766,
          "lane": "right",
          "x": 0.18,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.083
        },
        {
          "time": 83.88,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 84.159,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 84.484,
          "lane": "left",
          "x": 0.19,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.216
        },
        {
          "time": 84.701,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.216
        },
        {
          "time": 84.964,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.146
        },
        {
          "time": 85.115,
          "lane": "right",
          "x": 0.67,
          "type": "fish",
          "pitch": 85,
          "vocalDuration": 0.146
        },
        {
          "time": 85.26,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 85.528,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 85.795,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.267
        },
        {
          "time": 86.068,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.219
        },
        {
          "time": 86.286,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.245
        },
        {
          "time": 86.531,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.245
        },
        {
          "time": 86.781,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.094
        },
        {
          "time": 86.875,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.255
        },
        {
          "time": 87.76,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.31
        },
        {
          "time": 88.07,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.31
        },
        {
          "time": 88.385,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.099
        },
        {
          "time": 88.484,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 88.716,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 89,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.125
        },
        {
          "time": 89.125,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.099
        },
        {
          "time": 89.229,
          "lane": "right",
          "x": 0.41,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.237
        },
        {
          "time": 89.466,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.237
        },
        {
          "time": 89.75,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 89.991,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 90.233,
          "lane": "right",
          "x": 0.6,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.241
        },
        {
          "time": 90.536,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.38
        },
        {
          "time": 90.953,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.156
        },
        {
          "time": 91.109,
          "lane": "left",
          "x": 0.65,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.125
        },
        {
          "time": 91.24,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 91.49,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.25
        },
        {
          "time": 91.786,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 72,
          "vocalDuration": 0.104
        },
        {
          "time": 91.896,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 92.161,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 92.479,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.422
        },
        {
          "time": 92.953,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.109
        },
        {
          "time": 93.078,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 85,
          "vocalDuration": 0.198
        },
        {
          "time": 93.276,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.115
        },
        {
          "time": 93.469,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.292
        },
        {
          "time": 93.76,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 82,
          "vocalDuration": 0.292
        },
        {
          "time": 94.057,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.342,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.627,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 83,
          "vocalDuration": 0.285
        },
        {
          "time": 94.911,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.094
        },
        {
          "time": 95.292,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.083
        },
        {
          "time": 97.375,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 59,
          "vocalDuration": 0.323
        },
        {
          "time": 97.698,
          "lane": "left",
          "x": 0.57,
          "type": "iceCream",
          "pitch": 59,
          "vocalDuration": 0.323
        },
        {
          "time": 98.094,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.203
        },
        {
          "time": 98.302,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.193
        },
        {
          "time": 98.552,
          "lane": "right",
          "x": 0.18,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 98.786,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 99.021,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 99.286,
          "lane": "left",
          "x": 0.16,
          "type": "iceCream",
          "pitch": 67,
          "vocalDuration": 0.068
        },
        {
          "time": 99.354,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.151
        },
        {
          "time": 99.51,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 99.724,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 100.078,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.182
        },
        {
          "time": 100.26,
          "lane": "right",
          "x": 0.39,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 100.51,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 100.76,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.25
        },
        {
          "time": 101.01,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.115
        },
        {
          "time": 101.13,
          "lane": "right",
          "x": 0.38,
          "type": "cupcake",
          "pitch": 66,
          "vocalDuration": 0.146
        },
        {
          "time": 101.609,
          "lane": "left",
          "x": 0.15,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.302
        },
        {
          "time": 101.911,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.302
        },
        {
          "time": 102.219,
          "lane": "left",
          "x": 0.38,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.151
        },
        {
          "time": 102.375,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 102.641,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.266
        },
        {
          "time": 102.938,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.05
        },
        {
          "time": 102.99,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.276
        },
        {
          "time": 103.266,
          "lane": "right",
          "x": 0.15,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 103.563,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 103.859,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 104.156,
          "lane": "left",
          "x": 0.15,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 104.458,
          "lane": "right",
          "x": 0.58,
          "type": "cupcake",
          "pitch": 61,
          "vocalDuration": 0.224
        },
        {
          "time": 105.406,
          "lane": "left",
          "x": 0.35,
          "type": "candy",
          "pitch": 59,
          "vocalDuration": 0.281
        },
        {
          "time": 105.688,
          "lane": "right",
          "x": 0.57,
          "type": "sushi",
          "pitch": 59,
          "vocalDuration": 0.281
        },
        {
          "time": 106,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 106.234,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.161
        },
        {
          "time": 106.469,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 106.734,
          "lane": "right",
          "x": 0.18,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.266
        },
        {
          "time": 107,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.245,
          "lane": "right",
          "x": 0.39,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.49,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.245
        },
        {
          "time": 107.802,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.146
        },
        {
          "time": 107.948,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.232
        },
        {
          "time": 108.18,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.232
        },
        {
          "time": 108.469,
          "lane": "left",
          "x": 0.61,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.224
        },
        {
          "time": 108.693,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.177
        },
        {
          "time": 109.146,
          "lane": "left",
          "x": 0.59,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 109.401,
          "lane": "right",
          "x": 0.15,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.255
        },
        {
          "time": 109.688,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 109.927,
          "lane": "right",
          "x": 0.39,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 110.172,
          "lane": "left",
          "x": 0.16,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.313
        },
        {
          "time": 110.552,
          "lane": "right",
          "x": 0.58,
          "type": "sushi",
          "pitch": 62,
          "vocalDuration": 0.177
        },
        {
          "time": 110.729,
          "lane": "left",
          "x": 0.37,
          "type": "iceCream",
          "pitch": 63,
          "vocalDuration": 0.297
        },
        {
          "time": 111.057,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.172
        },
        {
          "time": 111.234,
          "lane": "left",
          "x": 0.59,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.48,
          "lane": "right",
          "x": 0.37,
          "type": "cupcake",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.727,
          "lane": "left",
          "x": 0.59,
          "type": "candy",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 111.973,
          "lane": "right",
          "x": 0.15,
          "type": "sushi",
          "pitch": 63,
          "vocalDuration": 0.246
        },
        {
          "time": 112.224,
          "lane": "left",
          "x": 0.36,
          "type": "iceCream",
          "pitch": 61,
          "vocalDuration": 0.229
        },
        {
          "time": 112.458,
          "lane": "right",
          "x": 0.37,
          "type": "fish",
          "pitch": 63,
          "vocalDuration": 0.125
        },
        {
          "time": 113.036,
          "lane": "left",
          "x": 0.15,
          "type": "donut",
          "pitch": 63,
          "vocalDuration": 0.068
        },
        {
          "time": 113.781,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.125
        },
        {
          "time": 113.911,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 114.161,
          "lane": "right",
          "x": 0.61,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.25
        },
        {
          "time": 114.438,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 114.672,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.234
        },
        {
          "time": 114.969,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 115.094,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.109
        },
        {
          "time": 115.208,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 115.458,
          "lane": "right",
          "x": 0.41,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 116.458,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 116.701,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.242
        },
        {
          "time": 116.943,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.188,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.432,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 117.693,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.276
        },
        {
          "time": 117.974,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.258
        },
        {
          "time": 118.232,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.258
        },
        {
          "time": 118.505,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.417
        },
        {
          "time": 118.948,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 119.089,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 119.307,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 119.543,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 119.78,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.236
        },
        {
          "time": 120.021,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 120.271,
          "lane": "right",
          "x": 0.41,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.25
        },
        {
          "time": 120.526,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.203
        },
        {
          "time": 121.229,
          "lane": "right",
          "x": 0.17,
          "type": "sushi",
          "pitch": 70,
          "vocalDuration": 0.333
        },
        {
          "time": 121.568,
          "lane": "left",
          "x": 0.39,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 121.807,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 122.047,
          "lane": "left",
          "x": 0.17,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.24
        },
        {
          "time": 122.307,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 122.523,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.216
        },
        {
          "time": 122.792,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 74,
          "vocalDuration": 0.083
        },
        {
          "time": 122.875,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.141
        },
        {
          "time": 123.021,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.26
        },
        {
          "time": 123.281,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.26
        },
        {
          "time": 123.583,
          "lane": "right",
          "x": 0.15,
          "type": "cupcake",
          "pitch": 65,
          "vocalDuration": 0.193
        },
        {
          "time": 123.781,
          "lane": "left",
          "x": 0.38,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.242
        },
        {
          "time": 124.023,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.242
        },
        {
          "time": 124.292,
          "lane": "left",
          "x": 0.17,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.406
        },
        {
          "time": 124.74,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.396
        },
        {
          "time": 125.229,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.245
        },
        {
          "time": 125.479,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 125.766,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.054,
          "lane": "right",
          "x": 0.41,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.341,
          "lane": "left",
          "x": 0.63,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.628,
          "lane": "right",
          "x": 0.19,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 126.916,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.287
        },
        {
          "time": 127.224,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 127.359,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 127.599,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 127.839,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 128.078,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.24
        },
        {
          "time": 128.323,
          "lane": "left",
          "x": 0.69,
          "type": "donut",
          "pitch": 90,
          "vocalDuration": 0.276
        },
        {
          "time": 128.599,
          "lane": "right",
          "x": 0.47,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.276
        },
        {
          "time": 128.901,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 129.245,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.083
        },
        {
          "time": 129.328,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.208
        },
        {
          "time": 129.542,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.141
        },
        {
          "time": 129.734,
          "lane": "left",
          "x": 0.21,
          "type": "donut",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.01,
          "lane": "right",
          "x": 0.65,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.286,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.563,
          "lane": "right",
          "x": 0.65,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 130.839,
          "lane": "left",
          "x": 0.65,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 131.115,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 131.391,
          "lane": "left",
          "x": 0.63,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.221
        },
        {
          "time": 131.612,
          "lane": "right",
          "x": 0.19,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.221
        },
        {
          "time": 131.849,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.071,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.293,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.222
        },
        {
          "time": 132.516,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.057
        },
        {
          "time": 133.026,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 133.182,
          "lane": "right",
          "x": 0.64,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 133.396,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.214
        },
        {
          "time": 133.656,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 133.905,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 134.153,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.248
        },
        {
          "time": 134.401,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.115
        },
        {
          "time": 134.708,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.167
        },
        {
          "time": 135.031,
          "lane": "left",
          "x": 0.19,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 135.151,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.216
        },
        {
          "time": 135.367,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.216
        },
        {
          "time": 135.589,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.083
        },
        {
          "time": 135.677,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 135.953,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.276
        },
        {
          "time": 136.234,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.161
        },
        {
          "time": 136.401,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.208
        },
        {
          "time": 136.964,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.161
        },
        {
          "time": 137.13,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.271
        },
        {
          "time": 137.427,
          "lane": "left",
          "x": 0.19,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.234
        },
        {
          "time": 137.677,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.292
        },
        {
          "time": 138.036,
          "lane": "left",
          "x": 0.42,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.13
        },
        {
          "time": 138.172,
          "lane": "right",
          "x": 0.65,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.208
        },
        {
          "time": 138.479,
          "lane": "left",
          "x": 0.65,
          "type": "iceCream",
          "pitch": 80,
          "vocalDuration": 0.276
        },
        {
          "time": 138.964,
          "lane": "right",
          "x": 0.43,
          "type": "fish",
          "pitch": 80,
          "vocalDuration": 0.141
        },
        {
          "time": 139.141,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 83,
          "vocalDuration": 0.172
        },
        {
          "time": 139.313,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.177
        },
        {
          "time": 139.495,
          "lane": "left",
          "x": 0.43,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.255
        },
        {
          "time": 139.828,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.268
        },
        {
          "time": 140.096,
          "lane": "left",
          "x": 0.2,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.268
        },
        {
          "time": 140.745,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 77,
          "vocalDuration": 0.177
        },
        {
          "time": 141.172,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.313
        },
        {
          "time": 141.484,
          "lane": "right",
          "x": 0.69,
          "type": "cupcake",
          "pitch": 90,
          "vocalDuration": 0.182
        },
        {
          "time": 141.667,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.135
        },
        {
          "time": 141.807,
          "lane": "right",
          "x": 0.42,
          "type": "sushi",
          "pitch": 76,
          "vocalDuration": 0.305
        },
        {
          "time": 142.112,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 76,
          "vocalDuration": 0.305
        },
        {
          "time": 142.417,
          "lane": "right",
          "x": 0.19,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.104
        },
        {
          "time": 142.656,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.198
        },
        {
          "time": 143.016,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 77,
          "vocalDuration": 0.115
        },
        {
          "time": 143.13,
          "lane": "left",
          "x": 0.25,
          "type": "candy",
          "pitch": 90,
          "vocalDuration": 0.161
        },
        {
          "time": 143.292,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.167
        },
        {
          "time": 143.458,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 77,
          "vocalDuration": 0.188
        },
        {
          "time": 143.651,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 143.928,
          "lane": "left",
          "x": 0.64,
          "type": "donut",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.206,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.483,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.277
        },
        {
          "time": 144.76,
          "lane": "right",
          "x": 0.19,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.094
        },
        {
          "time": 144.922,
          "lane": "left",
          "x": 0.39,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.214
        },
        {
          "time": 145.141,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.224
        },
        {
          "time": 145.37,
          "lane": "left",
          "x": 0.19,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.234
        },
        {
          "time": 145.635,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.224
        },
        {
          "time": 145.865,
          "lane": "left",
          "x": 0.39,
          "type": "candy",
          "pitch": 68,
          "vocalDuration": 0.12
        },
        {
          "time": 145.99,
          "lane": "right",
          "x": 0.59,
          "type": "sushi",
          "pitch": 64,
          "vocalDuration": 0.104
        },
        {
          "time": 146.099,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 68,
          "vocalDuration": 0.359
        },
        {
          "time": 146.484,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 146.721,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.237
        },
        {
          "time": 146.995,
          "lane": "right",
          "x": 0.2,
          "type": "cupcake",
          "pitch": 76,
          "vocalDuration": 0.271
        },
        {
          "time": 147.266,
          "lane": "left",
          "x": 0.41,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 147.492,
          "lane": "right",
          "x": 0.41,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.227
        },
        {
          "time": 147.729,
          "lane": "left",
          "x": 0.15,
          "type": "iceCream",
          "pitch": 65,
          "vocalDuration": 0.26
        },
        {
          "time": 147.995,
          "lane": "right",
          "x": 0.6,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 148.234,
          "lane": "left",
          "x": 0.38,
          "type": "donut",
          "pitch": 66,
          "vocalDuration": 0.24
        },
        {
          "time": 148.474,
          "lane": "right",
          "x": 0.61,
          "type": "cupcake",
          "pitch": 70,
          "vocalDuration": 0.391
        },
        {
          "time": 148.969,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.151
        },
        {
          "time": 149.125,
          "lane": "right",
          "x": 0.43,
          "type": "sushi",
          "pitch": 80,
          "vocalDuration": 0.151
        },
        {
          "time": 149.281,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.13
        },
        {
          "time": 149.484,
          "lane": "right",
          "x": 0.2,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.234
        },
        {
          "time": 149.766,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.094
        },
        {
          "time": 149.885,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 150.164,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.279
        },
        {
          "time": 150.458,
          "lane": "right",
          "x": 0.63,
          "type": "sushi",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 150.69,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.232
        },
        {
          "time": 150.969,
          "lane": "right",
          "x": 0.66,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.125
        },
        {
          "time": 151.125,
          "lane": "left",
          "x": 0.67,
          "type": "donut",
          "pitch": 85,
          "vocalDuration": 0.13
        },
        {
          "time": 151.271,
          "lane": "right",
          "x": 0.44,
          "type": "cupcake",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 151.542,
          "lane": "left",
          "x": 0.66,
          "type": "candy",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 151.813,
          "lane": "right",
          "x": 0.22,
          "type": "sushi",
          "pitch": 82,
          "vocalDuration": 0.271
        },
        {
          "time": 152.089,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 83,
          "vocalDuration": 0.271
        },
        {
          "time": 152.359,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 83,
          "vocalDuration": 0.271
        },
        {
          "time": 152.63,
          "lane": "left",
          "x": 0.17,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.167
        },
        {
          "time": 152.797,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.063
        },
        {
          "time": 152.896,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.161
        },
        {
          "time": 153.057,
          "lane": "right",
          "x": 0.66,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.323
        },
        {
          "time": 153.417,
          "lane": "left",
          "x": 0.61,
          "type": "iceCream",
          "pitch": 70,
          "vocalDuration": 0.328
        },
        {
          "time": 153.745,
          "lane": "right",
          "x": 0.39,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.326
        },
        {
          "time": 154.07,
          "lane": "left",
          "x": 0.61,
          "type": "donut",
          "pitch": 68,
          "vocalDuration": 0.326
        },
        {
          "time": 154.401,
          "lane": "right",
          "x": 0.17,
          "type": "cupcake",
          "pitch": 68,
          "vocalDuration": 0.089
        },
        {
          "time": 154.521,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 71,
          "vocalDuration": 0.227
        },
        {
          "time": 154.747,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 71,
          "vocalDuration": 0.227
        },
        {
          "time": 155.031,
          "lane": "left",
          "x": 0.19,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.094
        },
        {
          "time": 155.13,
          "lane": "right",
          "x": 0.64,
          "type": "fish",
          "pitch": 76,
          "vocalDuration": 0.13
        },
        {
          "time": 155.266,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 155.505,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.24
        },
        {
          "time": 155.766,
          "lane": "left",
          "x": 0.6,
          "type": "candy",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.012,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.259,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.247
        },
        {
          "time": 156.536,
          "lane": "right",
          "x": 0.17,
          "type": "fish",
          "pitch": 70,
          "vocalDuration": 0.396
        },
        {
          "time": 156.958,
          "lane": "left",
          "x": 0.42,
          "type": "donut",
          "pitch": 78,
          "vocalDuration": 0.182
        },
        {
          "time": 157.146,
          "lane": "right",
          "x": 0.43,
          "type": "cupcake",
          "pitch": 80,
          "vocalDuration": 0.125
        },
        {
          "time": 157.276,
          "lane": "left",
          "x": 0.2,
          "type": "candy",
          "pitch": 78,
          "vocalDuration": 0.094
        },
        {
          "time": 157.458,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.286
        },
        {
          "time": 157.781,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 72,
          "vocalDuration": 0.109
        },
        {
          "time": 157.896,
          "lane": "right",
          "x": 0.57,
          "type": "fish",
          "pitch": 59,
          "vocalDuration": 0.237
        },
        {
          "time": 158.133,
          "lane": "left",
          "x": 0.57,
          "type": "donut",
          "pitch": 59,
          "vocalDuration": 0.237
        },
        {
          "time": 158.469,
          "lane": "right",
          "x": 0.41,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.688,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.219
        },
        {
          "time": 158.958,
          "lane": "right",
          "x": 0.23,
          "type": "sushi",
          "pitch": 84,
          "vocalDuration": 0.318
        },
        {
          "time": 159.276,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 159.545,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 159.814,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.269
        },
        {
          "time": 160.089,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 160.375,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 160.661,
          "lane": "right",
          "x": 0.66,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.286
        },
        {
          "time": 161.021,
          "lane": "left",
          "x": 0.64,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.266
        },
        {
          "time": 161.286,
          "lane": "right",
          "x": 0.42,
          "type": "fish",
          "pitch": 78,
          "vocalDuration": 0.266
        },
        {
          "time": 161.552,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 161.821,
          "lane": "right",
          "x": 0.18,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.089,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.358,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.626,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 162.895,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 163.164,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.269
        },
        {
          "time": 163.432,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 74,
          "vocalDuration": 0.313
        },
        {
          "time": 163.979,
          "lane": "left",
          "x": 0.64,
          "type": "candy",
          "pitch": 76,
          "vocalDuration": 0.083
        },
        {
          "time": 164.063,
          "lane": "right",
          "x": 0.4,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.344,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.625,
          "lane": "right",
          "x": 0.18,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 164.906,
          "lane": "left",
          "x": 0.4,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.281
        },
        {
          "time": 165.224,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.302
        },
        {
          "time": 165.531,
          "lane": "left",
          "x": 0.18,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.208
        },
        {
          "time": 165.745,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.167
        },
        {
          "time": 166.026,
          "lane": "left",
          "x": 0.4,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.182
        },
        {
          "time": 166.214,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 166.479,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 166.745,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.01,
          "lane": "left",
          "x": 0.62,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.276,
          "lane": "right",
          "x": 0.18,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.266
        },
        {
          "time": 167.563,
          "lane": "left",
          "x": 0.41,
          "type": "iceCream",
          "pitch": 75,
          "vocalDuration": 0.12
        },
        {
          "time": 167.781,
          "lane": "right",
          "x": 0.4,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 167.995,
          "lane": "left",
          "x": 0.18,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.214
        },
        {
          "time": 168.214,
          "lane": "right",
          "x": 0.62,
          "type": "cupcake",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 168.512,
          "lane": "left",
          "x": 0.4,
          "type": "candy",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 168.811,
          "lane": "right",
          "x": 0.62,
          "type": "sushi",
          "pitch": 73,
          "vocalDuration": 0.299
        },
        {
          "time": 169.214,
          "lane": "left",
          "x": 0.62,
          "type": "iceCream",
          "pitch": 73,
          "vocalDuration": 0.099
        },
        {
          "time": 169.37,
          "lane": "right",
          "x": 0.41,
          "type": "fish",
          "pitch": 75,
          "vocalDuration": 0.151
        },
        {
          "time": 169.521,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 73,
          "vocalDuration": 0.297
        },
        {
          "time": 169.823,
          "lane": "right",
          "x": 0.18,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.094
        },
        {
          "time": 170.026,
          "lane": "left",
          "x": 0.37,
          "type": "candy",
          "pitch": 65,
          "vocalDuration": 0.151
        },
        {
          "time": 170.182,
          "lane": "right",
          "x": 0.39,
          "type": "sushi",
          "pitch": 68,
          "vocalDuration": 0.318
        },
        {
          "time": 170.505,
          "lane": "left",
          "x": 0.18,
          "type": "iceCream",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 170.753,
          "lane": "right",
          "x": 0.62,
          "type": "fish",
          "pitch": 71,
          "vocalDuration": 0.247
        },
        {
          "time": 171.031,
          "lane": "left",
          "x": 0.41,
          "type": "donut",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.285,
          "lane": "right",
          "x": 0.63,
          "type": "cupcake",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.538,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.253
        },
        {
          "time": 171.839,
          "lane": "right",
          "x": 0.38,
          "type": "sushi",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.063,
          "lane": "left",
          "x": 0.6,
          "type": "iceCream",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.286,
          "lane": "right",
          "x": 0.16,
          "type": "fish",
          "pitch": 66,
          "vocalDuration": 0.224
        },
        {
          "time": 172.547,
          "lane": "left",
          "x": 0.39,
          "type": "donut",
          "pitch": 70,
          "vocalDuration": 0.422
        },
        {
          "time": 173.042,
          "lane": "right",
          "x": 0.42,
          "type": "cupcake",
          "pitch": 78,
          "vocalDuration": 0.094
        },
        {
          "time": 173.141,
          "lane": "left",
          "x": 0.21,
          "type": "candy",
          "pitch": 80,
          "vocalDuration": 0.156
        },
        {
          "time": 173.297,
          "lane": "right",
          "x": 0.64,
          "type": "sushi",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 173.529,
          "lane": "left",
          "x": 0.42,
          "type": "iceCream",
          "pitch": 78,
          "vocalDuration": 0.232
        },
        {
          "time": 173.958,
          "lane": "right",
          "x": 0.61,
          "type": "fish",
          "pitch": 68,
          "vocalDuration": 0.057
        },
        {
          "time": 174.063,
          "lane": "left",
          "x": 0.62,
          "type": "donut",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 174.294,
          "lane": "right",
          "x": 0.4,
          "type": "cupcake",
          "pitch": 71,
          "vocalDuration": 0.232
        },
        {
          "time": 174.609,
          "lane": "left",
          "x": 0.63,
          "type": "candy",
          "pitch": 75,
          "vocalDuration": 0.391
        },
        {
          "time": 175.031,
          "lane": "right",
          "x": 0.23,
          "type": "sushi",
          "pitch": 84,
          "vocalDuration": 0.302
        },
        {
          "time": 175.344,
          "lane": "left",
          "x": 0.44,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 175.608,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 175.872,
          "lane": "left",
          "x": 0.22,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.264
        },
        {
          "time": 176.141,
          "lane": "right",
          "x": 0.66,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.41,
          "lane": "left",
          "x": 0.44,
          "type": "candy",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.679,
          "lane": "right",
          "x": 0.66,
          "type": "sushi",
          "pitch": 83,
          "vocalDuration": 0.269
        },
        {
          "time": 176.953,
          "lane": "left",
          "x": 0.66,
          "type": "iceCream",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.248,
          "lane": "right",
          "x": 0.44,
          "type": "fish",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.543,
          "lane": "left",
          "x": 0.66,
          "type": "donut",
          "pitch": 82,
          "vocalDuration": 0.295
        },
        {
          "time": 177.875,
          "lane": "right",
          "x": 0.22,
          "type": "cupcake",
          "pitch": 83,
          "vocalDuration": 0.052
        }
      ]
    }
  }
};
